import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { BrowserDynamicTestingModule } from '@angular/platform-browser-dynamic/testing';
import { ReturnStatement } from '@angular/compiler';
import { timeStamp } from 'console';
import { url } from 'inspector';
import { threadId } from 'worker_threads';
import { BASE_URL } from './base-url';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class GenericService {

  get() {
    throw new Error('Method not implemented.');
  }

  constructor(public http: HttpClient) { }

  base_URL = BASE_URL;

  menusType = new Subject();

  menuToggle = new Subject();

  notification = new Subject();

  customerView = new Subject();

  menuRefresh = new Subject();

  isLogin() {
    return !!sessionStorage.getItem('token')
  }

  getCustomerByMobile(mobile: any) {
    return this.http.get(this.base_URL + 'users/getByMobileNo/' + mobile)
  }

  updateOnSiteForUser(userId: any, isOnSite: any) {
    return this.http.put(this.base_URL + `users/updateOnSiteForUser/${userId}/${sessionStorage.getItem('cid')}/${isOnSite}`, {});
  }

  updateFavouriteList(data: any) {
    return this.http.put(this.base_URL + 'users/updateFavouriteList', data)
  }

  getUsersByMultipleLocationsAndIsOnSiteAndCid(data: any) {
    return this.http.post(this.base_URL + 'users/getUsersByMultipleLocationsAndIsOnSiteAndCid', data)
  }

  adminLogin(data: any) {
    return this.http.post(this.base_URL + 'users/login', data)
  }

  getUsersByPhNo(mobileNumber: any) {
    return this.http.get(this.base_URL + 'users/getUsersByPhNo/' + mobileNumber)
  }

  loginWithGoogleAuthenticator(data: any) {
    return this.http.post(this.base_URL + 'users/loginWithGoogleAuthenticator', data)
  }

  generateOtp(data: any) {
    return this.http.post(this.base_URL + 'users/generateOtp', data)
  }

  forgotPassword(data: any) {
    return this.http.post(this.base_URL + 'users/forgetPassword', data)
  }

  // addTask(body:any){
  //   return this.http.post(this.base_URL+"task",body)
  // }

  // taskFilterByWildSearch(searchKey:any){
  //   return this.http.get(this.base_URL + "task/filterByWildSearch/"+searchKey)
  // }

  // getAllTask(){
  //   return this.http.get(this.base_URL + "task/all")
  // }


  getAllByCreatedBy(pageNumber: any, recordsPerPage: any, userId: any) {
    return this.http.get(this.base_URL + "task/getAllByCreatedBy/" + sessionStorage.getItem('cid') + '/' + userId + '/' + pageNumber + '/' + recordsPerPage)
  }

  addTicketByMultiFieldSearch(body: any) {
    return this.http.post(this.base_URL + 'ticket/getTicketByMultiFieldSearch', body)
  }

  addTicket(body: any) {
    return this.http.post(this.base_URL + "ticketType", body)
  }

  addSubTicket(body: any) {
    return this.http.post(this.base_URL + "ticketSubType", body)
  }

  getAllSubTickets() {
    return this.http.get(this.base_URL + "ticketSubType/all/" + sessionStorage.getItem('cid'))
  }

  getTicketSubTypeById(id: any) {
    return this.http.get(this.base_URL + 'ticketSubType/' + id + "/" + sessionStorage.getItem('cid'))
  }

  updateTicketSubType(body: any) {
    return this.http.put(this.base_URL + 'ticketSubType/update', body)
  }

  addcontroller(body: any) {
    return this.http.post(this.base_URL + "ticket", body)
  }

  getcontroller(pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + "ticket/all/" + sessionStorage.getItem('cid') + '/' + pageNumber + '/' + recordsPerPage)
  }

  getAllTicketPostedByMe(pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'ticket/getAllTicketPostedByMe/' + sessionStorage.getItem('cid') + '/' + pageNumber + '/' + recordsPerPage)
  }

  getAllUnAssignedTicketTaskList(pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + "ticket/getAllUnAssignedTicketTaskList/" + sessionStorage.getItem('cid') + '/' + pageNumber + '/' + recordsPerPage)
  }
  // getAllUnAssignedTicketTaskList(){
  //   return this.http.get(this.base_URL + 'ticket/getAllUnAssignedTicketTaskList/'+sessionStorage.getItem('cid'))
  // }

  gettypeids() {
    return this.http.get(this.base_URL + 'ticketType/all/' + sessionStorage.getItem('cid'))
  }

  addUsers(body: any) {
    return this.http.post(this.base_URL + 'auth/selfRegister', body)
  }

  addChangePassword(body: any) {
    return this.http.post(this.base_URL + 'users/resetPassword', body)
  }

  deleteTicketType(id: any) {
    return this.http.delete(this.base_URL + 'ticketType/hardDelete/' + id)
  }

  getAllTickets() {
    return this.http.get(this.base_URL + "ticketType/all/" + sessionStorage.getItem('cid'))
  }

  getAllTicketTypeWithPagination(pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + "ticketType/getAllTicketTypeWithPagination/" + sessionStorage.getItem('cid') + '/' + pageNumber + '/' + recordsPerPage)
  }

  getTicketTypeByWildSearch(searchKey: any, pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'ticketType/getByWildSearch/' + searchKey + "/" + sessionStorage.getItem('cid') + "/" + pageNumber + '/' + recordsPerPage)
  }

  getTicketTypeById(id: any) {
    return this.http.get(this.base_URL + 'ticketType/' + id + '/' + sessionStorage.getItem('cid'))
  }

  getAllByTicketPriority(ticketPriority: any, pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'ticket/getAllByTicketPriority/' + pageNumber + "/" + recordsPerPage + "/" + ticketPriority + "/" + sessionStorage.getItem('cid'))
  }

  getAllByTicketSource(body: any) {
    return this.http.post(this.base_URL + 'ticket/getTicketBySource', body)
  }

  getAllNonWhatsappTickets(pageNo: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'ticket/getAllNonWhatsappTickets/' + sessionStorage.getItem('cid') + '/' + pageNo + '/' + recordsPerPage)
  }

  updateTicketPriorityTime(body: any) {
    return this.http.put(this.base_URL + 'ticket/updateTicketPriorityTime', body)
  }

  getAllByTaskPriority() {
    return this.http.get(this.base_URL + 'task/getAllByTaskPriority/' + sessionStorage.getItem('cid'))
  }

  updateTaskPriorityTime(body: any) {
    return this.http.put(this.base_URL + 'task/updateTaskPriorityTime', body)
  }


  getAllTicketSubTypeWithPagination(pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + "ticketSubType/getAllTicketSubTypeWithPagination/" + sessionStorage.getItem('cid') + '/' + pageNumber + '/' + recordsPerPage)
  }

  getTicketSubTypeByWildSearch(searchKey: any, pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'ticketSubType/getByWildSearch/' + sessionStorage.getItem('cid') + "/" + searchKey + "/" + pageNumber + '/' + recordsPerPage)
  }

  delTicketSubType(id: any) {
    return this.http.delete(this.base_URL + 'ticketSubType/hardDelete/' + id)
  }

  updateTicketType(body: any) {
    return this.http.put(this.base_URL + 'ticketType/update', body)
  }

  updateTicketDetails(body: any) {
    return this.http.put(this.base_URL + 'ticket/updateDetails', body)
  }

  updateTaskDescription(body: any) {
    return this.http.put(this.base_URL + 'task/updateDescription', body)
  }

  addTask(body: any) {
    return this.http.post(this.base_URL + "task", body)
  }

  taskFilterByWildSearch(searchKey: any) {
    return this.http.get(this.base_URL + "task/filterByWildSearch/" + sessionStorage.getItem('cid') + '/' + searchKey)
  }

  delTask(id: any) {
    return this.http.delete(this.base_URL + 'task/hardDelete/' + id)
  }

  getAllTask(pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + "task/all/" + sessionStorage.getItem('cid') + '/' + pageNumber + '/' + recordsPerPage)
  }

  getTaskById(id: any) {
    return this.http.get(this.base_URL + 'task/' + id + "/" + sessionStorage.getItem('cid'))
  }

  getAllTaskStatusWiseByAssignedToId(id: any) {
    return this.http.get(this.base_URL + 'task/getAllTaskStatusWiseByAssignedToIdWithoutPagination/' + id + "/" + sessionStorage.getItem('cid'))
  }

  getTaskCounts(id: any) {
    return this.http.get(this.base_URL + 'taskCount/getByUserId/' + sessionStorage.getItem('cid') + "/" + id)
  }

  filterByTaskStatusAndBetweenDates(pageNumber: any, recordsPerPage: any, status: any, startDate: any, endDate: any) {
    return this.http.get(this.base_URL + 'task/filterByTaskStatusAndBetweenDates/' + sessionStorage.getItem('cid') + '/{startDate}/{endDate}/' + pageNumber + '/' + recordsPerPage + '?status=' + status + '&startDate=' + startDate + '&endDate=' + endDate)
  }

  filterByTaskStatusAndBetweenDatesWithoutPagination(status: any, startDate: any, endDate: any) {
    return this.http.get(this.base_URL + 'task/filterByTaskStatusAndBetweenDatesWithoutPagination/' + sessionStorage.getItem('cid') + '/{startDate}/{endDate}/?status=' + status + '&startDate=' + startDate + '&endDate=' + endDate)
  }

  filterTaskByStatusAndUserIdAndDates(userId: any, pageNumber: any, recordsPerPage: any, status: any, fromDate: any, toDate: any) {
    return this.http.get(this.base_URL + 'task/filterByStatusAndUserIdAndDates/' + sessionStorage.getItem('cid') + '/' + userId + '/' + status + "/" + fromDate + '/' + toDate + '/' + pageNumber + '/' + recordsPerPage)
  }

  filterByStatusAndUserIdAndDatesWithoutPagination(userId: any, status: any, fromDate: any, toDate: any) {
    return this.http.get(this.base_URL + 'task/filterByStatusAndUserIdAndDatesWithoutPagination/' + sessionStorage.getItem('cid') + '/' + userId + '/' + status + "/" + fromDate + '/' + toDate)
  }


  getAllStatusCount() {
    return this.http.get(this.base_URL + 'task/getAllStatusCount/' + sessionStorage.getItem('cid'))
  }

  getTicketStatusCount() {
    return this.http.get(this.base_URL + 'ticket/getTicketStatusCount/' + sessionStorage.getItem('cid'))
  }

  updateTask(body: any) {
    return this.http.put(this.base_URL + 'task/update', body)
  }

  delTicketcontroller(id: any) {
    return this.http.delete(this.base_URL + 'ticket/hardDelete/' + id)
  }

  addProduct(body: any) {
    return this.http.post(this.base_URL + 'productMaster', body)
  }

  getProduct(pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'productMaster/all/' + sessionStorage.getItem('cid') + '/' + pageNumber + '/' + recordsPerPage)
  }

  getAllProducts() {
    return this.http.get(this.base_URL + 'productMaster/allProductMasterByCid/' + sessionStorage.getItem('cid'))
  }

  getAllByWildSearchWithoutPagination(searchKey: any) {
    return this.http.get(this.base_URL + 'productMaster/getAllByWildSearchWithoutPagination/' + searchKey + "/" + sessionStorage.getItem('cid'))
  }

  getProductByWildSearch(searchKey: any, pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'productMaster/getAllByWildSearch/' + searchKey + "/" + sessionStorage.getItem('cid') + "/" + pageNumber + '/' + recordsPerPage)
  }

  getProductById(id: any) {
    return this.http.get(this.base_URL + 'productMaster/' + id + '/' + sessionStorage.getItem('cid'))
  }

  delProduct(id: any) {
    return this.http.delete(this.base_URL + 'productMaster/hardDelete/' + id)
  }

  updateProduct(body: any) {
    return this.http.put(this.base_URL + 'productMaster/update', body)
  }


  getVendorByWildSearch(searchKey: any, pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'vendorMaster/getVendorByWildSearch/' + searchKey + "/" + sessionStorage.getItem('cid') + "/" + pageNumber + '/' + recordsPerPage)
  }

  getVendorMasterBySearchAndStatus(searchKey: any, status: any, pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'vendorMaster/getVendorMasterBySearchAndStatus/' + searchKey + "/" + status + "/" + sessionStorage.getItem('cid') + "/" + pageNumber + '/' + recordsPerPage)
  }

  addVendor(body: any) {
    return this.http.post(this.base_URL + 'vendorMaster', body)
  }

  getVendor(pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'vendorMaster/all/' + sessionStorage.getItem('cid') + '/' + pageNumber + '/' + recordsPerPage)
  }

  getAllVendor() {
    return this.http.get(this.base_URL + 'vendorMaster/getAllVendors/' + sessionStorage.getItem('cid'))
  }

  getAllVendorByStatus(status: any, pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'vendorMaster/getAllByStatus/' + status + "/" + sessionStorage.getItem('cid') + '/' + pageNumber + '/' + recordsPerPage)
  }

  getVendorById(id: any) {
    return this.http.get(this.base_URL + 'vendorMaster/' + id + '/' + sessionStorage.getItem('cid'))
  }

  delVendor(id: any) {
    return this.http.delete(this.base_URL + 'vendorMaster/hardDelete/' + id)
  }

  updateVendorStatus(vendorMasterId: any, body: any) {
    return this.http.put(this.base_URL + 'vendorMaster/updateStatus/' + vendorMasterId, body)
  }

  updateVendor(body: any) {
    return this.http.put(this.base_URL + 'vendorMaster/update', body)
  }

  addBranch(body: any) {
    return this.http.post(this.base_URL + 'branchMaster', body)
  }

  getBranch() {
    return this.http.get(this.base_URL + 'branchMaster/all/' + sessionStorage.getItem('cid'))
  }

  getBranchByCid(cid: any) {
    return this.http.get(this.base_URL + 'branchMaster/all/' + cid)
  }

  getBranchMastersByWildSearchKey(wildSearch: any) {
    return this.http.get(this.base_URL + 'branchMaster/getBranchMastersByWildSearchKey/' + wildSearch + "/" + sessionStorage.getItem('cid'))
  }

  getBranchById(branchMasterId: any) {
    return this.http.get(this.base_URL + 'branchMaster/' + branchMasterId + '/' + sessionStorage.getItem('cid'))
  }

  delBranch(id: any) {
    return this.http.delete(this.base_URL + 'branchMaster/hardDelete/' + id)
  }

  updateBranch(body: any) {
    return this.http.put(this.base_URL + 'branchMaster/update', body)
  }

  addlogedUsers(body: any) {
    return this.http.post(this.base_URL + 'users/insert', body)
  }

  assignUserRoles(body: any) {
    return this.http.post(this.base_URL + 'users/assignUserRoles', body)
  }

  updateAddRoleSetToAUser(body: any) {
    return this.http.put(this.base_URL + 'users/updateAddRoleSetToAUser', body)
  }

  getUsers() {
    return this.http.get(this.base_URL + 'users/allUsersByCid/' + sessionStorage.getItem('cid'))
  }

  getAllUsers(pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'users/all/' + sessionStorage.getItem('cid') + '/' + pageNumber + '/' + recordsPerPage)
  }

  // getUsersWithoutCustomers(){
  //   return this.http.get(this.base_URL+'users/getAllOrgUsers/'+sessionStorage.getItem('cid')+"/0/20")
  // }

  getUsersWithoutCustomers() {
    return this.http.get(this.base_URL + 'users/getAllOrgUsersWithoutPagination/' + sessionStorage.getItem('cid'))
  }

  getUserById(id: any) {
    return this.http.get(this.base_URL + 'users/' + id + '/' + sessionStorage.getItem('cid'))
  }

  getUserByIdAndCid(id: any, cid: any) {
    return this.http.get(this.base_URL + 'users/' + id + '/' + cid)
  }

  deleteUser(id: any) {
    return this.http.delete(this.base_URL + 'users/hardDelete/' + id)
  }

  updateUser(body: any) {
    return this.http.put(this.base_URL + 'users/update', body)
  }

  updateUserAuthMode(body: any) {
    return this.http.put(this.base_URL + 'users/updateUserAuthMode', body)
  }

  updateIsFavouriteListForUsers(userId: any, cid: any, isFavouriteList: any) {
    return this.http.put(this.base_URL + `users/updateIsFavouriteListForUsers/${userId}/${cid}/${isFavouriteList}`, {})
  }

  updateUserPreference(body: any) {
    return this.http.put(this.base_URL + 'users/updateUserPreference', body)
  }

  getSingleTask(id: any) {
    return this.http.get(this.base_URL + 'task/getTaskById/' + id + "/" + sessionStorage.getItem('cid'))
  }

  getAllTaskByTaskPriority(ticketPriority: any, pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'task/getAllTaskByTaskPriority/' + pageNumber + "/" + recordsPerPage + "/" + ticketPriority + "/" + sessionStorage.getItem('cid'))
  }

  getAllTaskByTaskPriorityWithoutPagination(ticketPriority: any) {
    return this.http.get(this.base_URL + 'task/getAllTaskByTaskPriorityWithoutPagination/' + ticketPriority + "/" + sessionStorage.getItem('cid'))
  }



  getTasksByStatus(pageNumber: any, recordsPerPage: any, status: any) {
    let header = {
      headers: new HttpHeaders(
        { status: `${status}` }
      )
    }
    return this.http.get(this.base_URL + 'task/filterByStatus/' + sessionStorage.getItem('cid') + '/' + status + '/' + pageNumber + '/' + recordsPerPage)
  }

  getSingleTicket(id: any) {
    return this.http.get(this.base_URL + 'ticket/' + id + "/" + sessionStorage.getItem('cid'))
  }

  updateTicketPicture(body: any) {
    return this.http.put(this.base_URL + 'ticket/updateTicketPicture', body)
  }

  addTicketTask(body: any) {
    return this.http.post(this.base_URL + 'ticket/insertTicketTask', body)
  }

  taskAssignToUser(body: any) {
    return this.http.post(this.base_URL + 'task/assignToUser', body)
  }

  ticketAssignToUser(body: any) {
    return this.http.post(this.base_URL + 'ticket/assignToUser', body)
  }

  updateStatus(body: any, taskId: any) {
    return this.http.put(this.base_URL + 'task/updateTaskStatus/' + taskId, body)
  }

  getTicketTaskByID(id: any) {
    return this.http.get(this.base_URL + 'ticket/getTicketTaskByTicketId/' + sessionStorage.getItem('cid') + '/' + id)
  }

  getTicketTaskByTicketId(id: any) {
    return this.http.get(this.base_URL + 'ticket/getTicketTaskByTicketId/' + sessionStorage.getItem('cid') + '/' + id)
  }

  getAllTicketTask() {
    return this.http.get(this.base_URL + 'ticket/getAllTicketTask/' + sessionStorage.getItem('cid'))
  }

  getAllTicketTaskWithPagination(pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'ticket/getAllTicketTask/' + sessionStorage.getItem('cid') + '/' + pageNumber + '/' + recordsPerPage)
  }

  getAllLMO() {
    return this.http.get(this.base_URL + 'lmoData/all/' + sessionStorage.getItem('cid'))
  }

  deleteLMO(id: any) {
    return this.http.delete(this.base_URL + 'lmoData/hardDelete/' + id)
  }

  getLMOById(status: any) {
    return this.http.get(this.base_URL + 'lmoData/getByApplicationStatus/' + status)
  }

  updateLMO(body: any) {
    return this.http.put(this.base_URL + 'lmoData/update', body)
  }

  getAllProspect() {
    return this.http.get(this.base_URL + 'prospectRegistration/all/' + sessionStorage.getItem('cid'))
  }

  getByStatusWithPagination(status: any, pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'prospectRegistration/getByStatusWithPagination/' + sessionStorage.getItem('cid') + "/" + status + '/' + pageNumber + '/' + recordsPerPage)
  }

  getAllProspectRegistrationWildSearchWithPagination(searchKey: any, pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'prospectRegistration/getAllProspectRegistrationWildSearchWithPagination/' + searchKey + "/" + pageNumber + '/' + recordsPerPage)
  }

  getAllProspectRegistrationWithPagination(pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'prospectRegistration/getAllProspectRegistrationWithPagination/' + sessionStorage.getItem('cid') + '/' + pageNumber + '/' + recordsPerPage)
  }

  showOtpProspect(phoneNo: any, emailId: any) {
    return this.http.get(this.base_URL + 'prospectRegistration/showOtp/' + phoneNo + '/' + emailId + '/' + sessionStorage.getItem('cid'))
  }

  showPhoneOtp(phoneNo: any) {
    return this.http.get(this.base_URL + 'prospectRegistration/showPhoneOtp/' + phoneNo + '/' + sessionStorage.getItem('cid'))
  }

  showEmailOtp(emailId: any) {
    return this.http.get(this.base_URL + 'prospectRegistration/showEmailOtp/' + emailId + '/' + sessionStorage.getItem('cid'))
  }



  prospectAssignToUser(body: any) {
    return this.http.post(this.base_URL + 'prospectRegistration/assignToUser', body)
  }

  deleteProspect(id: any) {
    return this.http.delete(this.base_URL + 'prospectRegistration/hardDelete/' + id)
  }

  getProspectByID(id: any) {
    return this.http.get(this.base_URL + 'prospectRegistration/' + id + '/' + sessionStorage.getItem('cid'))
  }

  getProspectByStatus(status: any) {
    return this.http.get(this.base_URL + 'prospectRegistration/getByStatus/' + sessionStorage.getItem('cid') + "/" + status)
  }

  updateProspect(body: any) {
    this.http.put(this.base_URL + 'prospectRegistration/update', body)
  }

  addMaterial(body: any) {
    return this.http.post(this.base_URL + 'materialPurchase', body)
  }

  getAllMaterial(pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'materialPurchase/all/' + sessionStorage.getItem('cid') + '/' + pageNumber + '/' + recordsPerPage)
  }

  getMaterialPurchaseByWildSearch(searchKey: any, pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'materialPurchase/getByWildSearch/' + searchKey + "/" + sessionStorage.getItem('cid') + "/" + pageNumber + '/' + recordsPerPage)
  }

  getMaterialById(id: any) {
    return this.http.get(this.base_URL + 'materialPurchase/' + id + '/' + sessionStorage.getItem('cid'))
  }

  deleteMaterialPurchase(id: any) {
    return this.http.delete(this.base_URL + 'materialPurchase/hardDelete/' + id)
  }

  getMaterialIssueByWildSearch(searchKey: any, pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'materialIssue/getByWildSearch/' + sessionStorage.getItem('cid') + "/" + searchKey + "/" + pageNumber + '/' + recordsPerPage)
  }

  getAllMaterialIssueByWildSearchWithIssueStatus(searchKey: any, status: any, pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'materialIssue/getAllMaterialIssueByWildSearchWithIssueStatus/' + sessionStorage.getItem('cid') + "/" + status + "/" + searchKey + "/" + pageNumber + '/' + recordsPerPage)
  }

  getMaterialIssueById(id: any) {
    return this.http.get(this.base_URL + 'materialIssue/' + id + '/' + sessionStorage.getItem('cid'))
  }

  addPlan(body: any) {
    return this.http.post(this.base_URL + 'planInfo', body)
  }

  getAllPlans() {
    return this.http.get(this.base_URL + 'planInfo/all/' + sessionStorage.getItem('cid'))
  }

  getPlanById(id: any) {
    return this.http.get(this.base_URL + 'planInfo/' + id + '/' + sessionStorage.getItem('cid'))
  }

  deletePlan(id: any) {
    return this.http.delete(this.base_URL + 'planInfo/hardDelete/' + id)
  }

  updatePlan(body: any) {
    return this.http.put(this.base_URL + 'planInfo/update', body)
  }

  addService(body: any) {
    return this.http.post(this.base_URL + 'serviceDefinition', body)
  }

  getAllServices() {
    return this.http.get(this.base_URL + 'serviceDefinition/all/' + sessionStorage.getItem('cid'))
  }

  getAllServicesWithPagination(pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'serviceDefinition/all/' + sessionStorage.getItem('cid') + "/" + pageNumber + '/' + recordsPerPage)
  }

  getServiceDefinitionByWildSearch(searchKey: any, pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'serviceDefinition/getByWildSearch/' + searchKey + "/" + sessionStorage.getItem('cid') + "/" + pageNumber + '/' + recordsPerPage)
  }

  getServiceById(id: any) {
    return this.http.get(this.base_URL + 'serviceDefinition/' + id + '/' + sessionStorage.getItem('cid'))
  }

  deleteService(id: any) {
    return this.http.delete(this.base_URL + 'serviceDefinition/hardDelete/' + id)
  }

  updateService(body: any) {
    return this.http.put(this.base_URL + 'serviceDefinition/update', body)
  }

  addVerification(id: any, body: any) {
    return this.http.put(this.base_URL + 'prospectRegistration/updateApplicationStatus/' + id, body)
  }

  insertConversation(body: any) {
    return this.http.post(this.base_URL + 'users/insertConversation', body)
  }

  getConversationByUserId(userId: any) {
    return this.http.get(this.base_URL + 'users/conversationByUserId/' + userId)
  }

  addConversationByConversationId(conversationId: any, body: any) {
    return this.http.post(this.base_URL + 'users/addConversationByConversationId/' + conversationId, body)
  }

  getConversationById(conversationId: any) {
    return this.http.get(this.base_URL + 'users/conversationById/' + conversationId + '/' + sessionStorage.getItem('cid'))
  }

  addApproval(id: any, body: any) {
    return this.http.put(this.base_URL + 'prospectRegistration/updateApplicationStatus/' + id, body)
  }

  addReject(id: any, body: any) {
    return this.http.put(this.base_URL + 'prospectRegistration/updateApplicationStatus/' + id, body)
  }

  addIssue(body: any) {
    return this.http.post(this.base_URL + 'materialIssue', body)
  }

  approveIssue(body: any) {
    return this.http.put(this.base_URL + 'materialIssue/updateIssueStatus', body)
  }

  updatePurchaseStatus(body: any) {
    return this.http.put(this.base_URL + 'materialPurchase/updatePurchaseStatus', body)
  }

  updateTransferStatus(body: any) {
    return this.http.put(this.base_URL + 'materialTransfer/updateTransferStatus', body)
  }

  getMaterialTransferByWildSearch(searchKey: any, pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'materialTransfer/getByWildSearch/' + sessionStorage.getItem('cid') + "/" + searchKey + "/" + pageNumber + '/' + recordsPerPage)
  }

  getAllIssues(pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'materialIssue/all/' + sessionStorage.getItem('cid') + '/' + pageNumber + '/' + recordsPerPage)
  }

  getAllMaterilaIssueByStatus(pageNumber: any, recordsPerPage: any, status: any) {
    return this.http.get(this.base_URL + 'materialIssue/getByLatestStatus/' + sessionStorage.getItem('cid') + '/' + status + '/' + pageNumber + '/' + recordsPerPage)
  }

  getMaterialByID(id: any) {
    return this.http.get(this.base_URL + 'materialIssue/' + id)
  }

  getByLastestStatus(status: any) {
    return this.http.get(this.base_URL + 'materialIssue/getByLatestStatus/' + sessionStorage.getItem('cid') + '/' + status)
  }

  updateMaterialById(id: any, body: any) {
    return this.http.put(this.base_URL + 'materialIssue/update' + id, body)
  }

  deleteIssue(id: any) {
    return this.http.delete(this.base_URL + 'materialIssue/hardDelete/' + id)
  }

  addTransfer(body: any) {
    return this.http.post(this.base_URL + 'materialTransfer', body)
  }

  getAllTransfer(pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'materialTransfer/all/' + sessionStorage.getItem('cid') + '/' + pageNumber + '/' + recordsPerPage)
  }

  getTransferById(id: any) {
    return this.http.get(this.base_URL + 'materialTransfer/' + id + '/' + sessionStorage.getItem('cid'))
  }

  deleteTransfer(id: any) {
    return this.http.delete(this.base_URL + 'materialTransfer/hardDelete/' + id)
  }

  getProductStock(pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'productStockInfo/all/' + sessionStorage.getItem('cid') + '/' + pageNumber + '/' + recordsPerPage)
  }

  getProductStockByName(name: any, pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'productStockInfo/getByProductName/' + sessionStorage.getItem('cid') + '/' + name + '/' + pageNumber + '/' + recordsPerPage)
  }

  getLatestProductStockInfoByProductName(name: any, pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'productStockInfo/getLatestProductStockInfoByProductName/' + sessionStorage.getItem('cid') + '/' + name + '/' + pageNumber + '/' + recordsPerPage)
  }

  getProductStockInfoByWildSearch(searchKey: any, pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'productStockInfo/getByWildSearch/' + sessionStorage.getItem('cid') + "/" + searchKey + "/" + pageNumber + '/' + recordsPerPage)
  }

  getAllProductLatestBalance(pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'productStockInfo/getAllProductLatestBalance/' + sessionStorage.getItem('cid') + '/' + pageNumber + '/' + recordsPerPage)
  }

  getAllNotification() {
    return this.http.get(this.base_URL + 'notification/all/' + sessionStorage.getItem('cid'))
  }

  addUserParameter(body: any) {
    return this.http.post(this.base_URL + 'userParameter', body)
  }

  addUserParameterByUserId(userId: any, body: any) {
    return this.http.post(this.base_URL + 'userParameter/addUserParameter/' + userId, body)
  }

  getUserParameterByUserId(userId: any) {
    return this.http.get(this.base_URL + 'userParameter/getByUserId/' + userId + '/' + sessionStorage.getItem('cid'))
  }

  getParams() {
    return this.http.get(this.base_URL + 'predefinedParameter/all/' + sessionStorage.getItem('cid'))
  }

  getAllPredefinedParameterWithPagination(pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'predefinedParameter/getAllPredefinedParameterWithPagination/' + sessionStorage.getItem('cid') + '/' + pageNumber + '/' + recordsPerPage)
  }

  getPredefinedParameterByWildSearch(searchKey: any, pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'predefinedParameter/getByWildSearch/' + searchKey + "/" + sessionStorage.getItem('cid') + "/" + pageNumber + '/' + recordsPerPage)
  }

  getParamById(id: any) {
    return this.http.get(this.base_URL + 'predefinedParameter/' + id + '/' + sessionStorage.getItem('cid'))
  }

  addParam(body: any) {
    return this.http.post(this.base_URL + 'predefinedParameter', body)
  }

  deleteParam(id: any) {
    return this.http.delete(this.base_URL + 'predefinedParameter/hardDelete/' + id)
  }

  updateParam(body: any) {
    return this.http.put(this.base_URL + 'predefinedParameter/update', body)
  }

  getParamByType(type: any) {
    return this.http.get(this.base_URL + 'predefinedParameter/getAllByType/' + sessionStorage.getItem('cid') + '/' + type)
  }

  updateTaskPercentage(body: any) {
    return this.http.post(this.base_URL + 'ticket/updateTicketStatus/', body)
  }

  updateTicketStatus(ticketId: any, body: any) {
    return this.http.put(this.base_URL + 'ticket/updateTicketStatus/' + ticketId, body)
  }

  updateTicketImage(body: any) {
    return this.http.put(this.base_URL + 'ticket/update', body)
  }

  updateTicketNotes(body: any) {
    return this.http.put(this.base_URL + 'ticket/updateTicketNotes', body)
  }

  updateTaskNotes(body: any) {
    return this.http.put(this.base_URL + 'task/updateTaskNotes/', body)
  }

  updatedUserParamValueForAllUsers(body: any) {
    return this.http.post(this.base_URL + 'userParameter/updatedUserParamValueForAllUsers', body)
  }

  getAllByCidAndBetweenDates(body: any) {
    return this.http.post(this.base_URL + 'clientLocation/getAllByCidAndUsernameAndBetweenDates', body)
  }

  getEmployeeLocationTrackingByIdAndBetweenDates(userId: any, fromDate: any, toDate: any) {
    return this.http.get(this.base_URL + 'employee_location_tracking/getEmployeeLocationTrackingByIdAndBetweenDates/' + userId + '/' + fromDate + '/' + toDate + '/' + sessionStorage.getItem('cid'))
  }

  getEmployeeLocationTrackingByIdAndLastDatetime(userIds: any) {
    return this.http.get(this.base_URL + 'employee_location_tracking/getEmployeeLocationTrackingByIdAndLastDatetime/' + userIds + '/' + sessionStorage.getItem('cid'))
  }

  getAllObjectSummary() {
    return this.http.get(this.base_URL + 'objectSummary/all/' + sessionStorage.getItem('cid'))
  }

  getObjectConditionCount() {
    return this.http.get(this.base_URL + 'objectConditionCount/all/' + sessionStorage.getItem('cid'))
  }

  getInventoryDashboard(cid: any, branch?: string, department?: string) {
    let params = new HttpParams();
    if (branch) params = params.set('branch', branch);
    if (department) params = params.set('department', department);
    return this.http.get(`${this.base_URL}object-dashboard/inventory/${cid}`, { params });
  }

  getOperationsDashboard(cid: any, branch?: string, department?: string) {
    let params = new HttpParams();
    if (branch) params = params.set('branch', branch);
    if (department) params = params.set('department', department);
    return this.http.get(`${this.base_URL}object-dashboard/operations/${cid}`, { params });
  }

  getAllocationsDashboard(cid: any, branch?: string, department?: string) {
    let params = new HttpParams();
    if (branch) params = params.set('branch', branch);
    if (department) params = params.set('department', department);
    return this.http.get(`${this.base_URL}object-dashboard/allocations/${cid}`, { params });
  }

  getLogisticsDashboard(cid: any, branch?: string, department?: string) {
    let params = new HttpParams();
    if (branch) params = params.set('branch', branch);
    if (department) params = params.set('department', department);
    return this.http.get(`${this.base_URL}object-dashboard/logistics/${cid}`, { params });
  }

  addObjectTemplate(body: any) {
    return this.http.post(this.base_URL + 'objectTemplate', body)
  }

  getAllObjectTemplateByWildSearch(wildSearch: any) {
    return this.http.get(this.base_URL + 'objectTemplate/getAllObjectTemplateByWildSearch/' + wildSearch + "/" + sessionStorage.getItem('cid'))
  }

  getObjectTemplateByWildSearchWithPagination(
    searchText: string,
    pageNo: number,
    recordsPerPage: number
  ) {
    const url = `${this.base_URL}objectTemplate/getAllObjectTemplateByWildSearchWithPagination/${searchText}/${pageNo}/${recordsPerPage}`;
    return this.http.get(url);
  }

  getAllObjectTemplate() {
    return this.http.get(this.base_URL + 'objectTemplate/all/' + sessionStorage.getItem('cid'))
  }

  getAllObjectTemplateWithPagination(pageNo: any, recordsPerPage: any) {
    return this.http.get(`${this.base_URL}objectTemplate/getAllObjectTemplateWithPagination/${pageNo}/${recordsPerPage}`);
  }

  getObjectTemplateById(id: any) {
    return this.http.get(this.base_URL + 'objectTemplate/' + id + '/' + sessionStorage.getItem('cid'))
  }

  checkAllByNameAndCid(body: any) {
    return this.http.post(this.base_URL + 'objectInfo/checkAllByNameAndCid', body)
  }

  deleteObjectTemplate(id: any) {
    return this.http.delete(this.base_URL + 'objectTemplate/hardDelete/' + id)
  }

  updateObjectTemplateIcon(body: any) {
    return this.http.put(this.base_URL + 'objectTemplate/updateObjectTemplateIcon', body)
  }

  updateObjectTemplate(body: any) {
    return this.http.put(this.base_URL + 'objectTemplate/update', body)
  }

  productOpeningBalance(body: any) {
    return this.http.post(this.base_URL + 'productOpeningBalance', body)
  }

  getAllProductOpeningBalance(pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'productOpeningBalance/all/' + sessionStorage.getItem('cid') + '/' + pageNumber + '/' + recordsPerPage)
  }

  getProductOpeningBalanceByWildSearch(searchKey: any, pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'productOpeningBalance/getByWildSearch/' + sessionStorage.getItem('cid') + "/" + searchKey + "/" + pageNumber + '/' + recordsPerPage)
  }

  getProductOpeningBalanceId(id: any) {
    return this.http.get(this.base_URL + 'productOpeningBalance/getById/' + id + '/' + sessionStorage.getItem('cid'))
  }

  approveOpeningBalance(body: any) {
    return this.http.put(this.base_URL + 'productOpeningBalance/approveOpeningBalance', body)
  }

  getAllRoles() {
    return this.http.get(this.base_URL + 'roles/all/' + sessionStorage.getItem('cid'))
  }

  getRolesByWildSearch(searchKey: any, pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'roles/getRolesByWildSearch/' + searchKey + "/" + sessionStorage.getItem('cid') + "/" + pageNumber + '/' + recordsPerPage)
  }

  getRolesByUser() {
    return this.http.get(this.base_URL + 'roles/getRolesByUser')
  }

  getRoleById(id: any) {
    return this.http.get(this.base_URL + 'roles/' + id + '/' + sessionStorage.getItem('cid'))
  }

  getUserRoleByUserMobileAndCid(mobile: any) {
    return this.http.get(this.base_URL + 'users/getUserRoleByUserMobileAndCid/' + mobile + '/' + sessionStorage.getItem('cid'))
  }

  getUserRoleByUserMobileAndCidWithCid(mobile: any, cid: any) {
    return this.http.get(this.base_URL + 'users/getUserRoleByUserMobileAndCid/' + mobile + '/' + cid)
  }

  deleteUserRole(userMobileNo: any, roleId: any) {
    return this.http.delete(this.base_URL + 'users/deleteUserRole/' + userMobileNo + "/" + sessionStorage.getItem('cid') + "/" + roleId)
  }

  addRole(body: any) {
    return this.http.post(this.base_URL + 'roles', body)
  }

  deleteRole(id: any) {
    return this.http.delete(this.base_URL + 'roles/hardDelete/' + id)
  }

  updateRole(body: any) {
    return this.http.put(this.base_URL + 'roles/update', body)
  }

  addTaskMaster(body: any) {
    return this.http.post(this.base_URL + 'taskMaster', body)
  }

  getAllTaskMaster() {
    return this.http.get(this.base_URL + 'taskMaster/all/' + sessionStorage.getItem('cid'))
  }

  getAllTaskMasterWithPagination(pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + "taskMaster/getAllTaskMasterWithPagination/" + sessionStorage.getItem('cid') + '/' + pageNumber + '/' + recordsPerPage)
  }

  getTaskByWildSearch(searchKey: any, pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'task/filterByWildSearch/' + sessionStorage.getItem('cid') + "/" + searchKey + "/" + pageNumber + '/' + recordsPerPage)
  }

  getTaskMasterByWildSearch(searchKey: any, pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'taskMaster/getByWildSearch/' + sessionStorage.getItem('cid') + "/" + searchKey + "/" + pageNumber + '/' + recordsPerPage)
  }

  getAllTaskNameAndDescription() {
    return this.http.get(this.base_URL + 'taskMaster/getAllTaskNameAndDescription/' + sessionStorage.getItem('cid'))
  }

  getTaskMasterById(id: any) {
    return this.http.get(this.base_URL + 'taskMaster/' + id + '/' + sessionStorage.getItem('cid'))
  }

  taskFilterByStatus(status: any, pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'task/filterByAssignedTo/' + sessionStorage.getItem('cid') + "/" + status + "/" + pageNumber + '/' + recordsPerPage)
  }

  taskFilterByStatusAndUserIdAndDates(body: any, pageNumber: any, recordsPerPage: any) {
    return this.http.post(this.base_URL + 'task/filterByStatusAndUserIdAndDates/' + sessionStorage.getItem('cid') + '/' + pageNumber + '/' + recordsPerPage, body)
  }

  taskFilterByAssignedTo(userId: any, pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'task/filterByAssignedTo/' + sessionStorage.getItem('cid') + "/" + userId + "/" + pageNumber + '/' + recordsPerPage)
  }

  filterByAssignedToWithoutPagination(userId: any) {
    return this.http.get(this.base_URL + 'task/filterByAssignedToWithoutPagination/' + sessionStorage.getItem('cid') + "/" + userId)
  }

  getUserAttendence(date: any) {
    return this.http.get(this.base_URL + 'userAttendance/getByDate/' + sessionStorage.getItem('cid') + '/' + date)
  }

  getUserAttendenceByUserAttendanceId(userAttendanceId: any) {
    return this.http.get(this.base_URL + 'userAttendance/' + userAttendanceId + "/" + sessionStorage.getItem('cid'))
  }

  getUserAttendenceByUserIdAndDate(id: any, date: any) {
    return this.http.get(this.base_URL + 'userAttendance/getByUserIdAndDate/' + id + '/' + date)
  }

  getCustomerParams() {
    return this.http.get(this.base_URL + 'customerParam/all/' + sessionStorage.getItem('cid'))
  }

  getAllCustomerParamWithPagination(pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + "customerParam/getAllCustomerParamWithPagination/" + sessionStorage.getItem('cid') + '/' + pageNumber + '/' + recordsPerPage)
  }

  getCustomerParamByWildSearch(searchKey: any, pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'customerParam/getByWildSearch/' + searchKey + "/" + sessionStorage.getItem('cid') + "/" + pageNumber + '/' + recordsPerPage)
  }

  getCustomerParamsById(id: any) {
    return this.http.get(this.base_URL + 'customerParam/' + id + '/' + sessionStorage.getItem('cid'))
  }

  addCustomerParam(body: any) {
    return this.http.post(this.base_URL + 'customerParam', body)
  }

  deleteCustomerParam(id: any) {
    return this.http.delete(this.base_URL + 'customerParam/hardDelete/' + id)
  }

  updateCustomerParams(body: any) {
    return this.http.put(this.base_URL + 'customerParam/update', body)
  }

  addCustomerUsage(body: any) {
    return this.http.post(this.base_URL + 'customerNetUsageInfo', body)
  }

  getCustomerUsage() {
    return this.http.get(this.base_URL + 'customerNetUsageInfo/all/' + sessionStorage.getItem('cid'))
  }

  getCustomerUsageById(id: any) {
    return this.http.get(this.base_URL + 'customerNetUsageInfo/' + id + '/' + sessionStorage.getItem('cid'))
  }

  deleteCustomerUsage(id: any) {
    return this.http.delete(this.base_URL + 'customerNetUsageInfo/hardDelete/' + id)
  }

  updateCustomerUsage(body: any) {
    return this.http.put(this.base_URL + 'customerNetUsageInfo/update', body)
  }

  addMarketingData(body: any) {
    return this.http.post(this.base_URL + 'marketingData', body)
  }

  getMarketingData() {
    return this.http.get(this.base_URL + 'marketingData/all/' + sessionStorage.getItem('cid'))
  }

  getMarketingDataById(id: any) {
    return this.http.get(this.base_URL + 'marketingData/' + id + '/' + sessionStorage.getItem('cid'))
  }

  updateMarketingData(body: any) {
    return this.http.put(this.base_URL + 'marketingData/update', body)
  }

  updateMarketingDataStatus(body: any, id: any) {
    return this.http.post(this.base_URL + 'marketingData/updateMarketingDataStatus/' + id, body)
  }

  addCustomerInfo(body: any) {
    return this.http.post(this.base_URL + 'customerInfo', body)
  }

  getCustomerInfo(pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'customerInfo/all/' + sessionStorage.getItem('cid') + '/' + pageNumber + '/' + recordsPerPage)
  }

  getAllCustomerWithoutPagination() {
    return this.http.get(this.base_URL + 'customerInfo/allWithoutPagination/' + sessionStorage.getItem('cid'))
  }

  getAllCustomerResponse() {
    return this.http.get(this.base_URL + 'customerInfo/getAllCustomerResponse/' + sessionStorage.getItem('cid'))
  }

  getCustomerInfoById(id: any) {
    return this.http.get(this.base_URL + 'customerInfo/' + id + '/' + sessionStorage.getItem('cid'))
  }

  deleteCustomerInfo(id: any) {
    return this.http.delete(this.base_URL + 'customerInfo/hardDelete/' + id)
  }

  updateCustomerInfo(body: any) {
    return this.http.put(this.base_URL + 'customerInfo/update', body)
  }

  generateInvoiceForAllCustomers(body: any) {
    return this.http.post(this.base_URL + 'customerPlanInfo/generateInvoiceForAllCustomers', body)
  }

  AllCustomersInvoiceHistory() {
    return this.http.get(this.base_URL + 'customerInvoiceHistory/all/' + sessionStorage.getItem('cid'))
  }

  addCustomerNRCCharges(body: any) {
    return this.http.post(this.base_URL + 'customerNRCCharges', body)
  }

  getAllCustomerNRCCharges() {
    return this.http.get(this.base_URL + 'customerNRCCharges/all/' + sessionStorage.getItem('cid'))
  }

  getCustomerNRCChargesById(id: any) {
    return this.http.get(this.base_URL + 'customerNRCCharges/' + id)
  }

  addCustomerUCCharges(body: any) {
    return this.http.post(this.base_URL + 'customerUCCharges', body)
  }

  getAllCustomerUCCharges() {
    return this.http.get(this.base_URL + 'customerUCCharges/all/' + sessionStorage.getItem('cid'))
  }

  getCustomerUCChargesById(id: any) {
    return this.http.get(this.base_URL + 'customerUCCharges/' + id)
  }

  approveCustomerInfo(body: any) {
    return this.http.put(this.base_URL + 'customerInfo/updateStatus', body)
  }

  rejectCustomerInfo(body: any) {
    return this.http.put(this.base_URL + 'customerInfo/updateStatus/update', body)
  }

  pendingForApproval(body: any) {
    return this.http.post(this.base_URL + 'customerInfo/getAllByLatestStatus/' + sessionStorage.getItem('cid'), body)
  }

  addRoute(body: any) {
    return this.http.post(this.base_URL + 'route/insertRoute', body)
  }

  getAllRoute() {
    return this.http.get(this.base_URL + 'route/route/all/' + sessionStorage.getItem('cid'))
  }

  getRouteById(id: any) {
    return this.http.get(this.base_URL + 'route/getRoute/' + id + '/' + sessionStorage.getItem('cid'))
  }

  deleteRoute(id: any) {
    return this.http.delete(this.base_URL + 'route/hardDeleteRoute/' + id)
  }

  updateRoute(body: any) {
    return this.http.put(this.base_URL + 'route/updateRoute', body)
  }

  uploadIdProofAttachment(file: any) {
    const form: FormData = new FormData();
    form.append('file', file)
    return this.http.post(this.base_URL, form)
  }

  uploadFile(file: any) {
    const form: FormData = new FormData();
    form.append('file', file)
    return this.http.post(this.base_URL + 'upload-file/uploadFile?cid=' + sessionStorage.getItem('cid'), form)
  }

  // uploadCustomerImage(id:any,file:any){
  //   const form : FormData = new FormData();
  //   form.append('file',file)
  //   return this.http.get(this.base_URL+'customerInfo/uploadImage?id=/'+id,form)
  // }

  addCompanyNews(body: any) {
    return this.http.post(this.base_URL + 'companyNews', body)
  }

  getAllCompanyNews() {
    return this.http.get(this.base_URL + 'companyNews/all/' + sessionStorage.getItem('cid'))
  }

  getCompanyNewsById(id: any) {
    return this.http.get(this.base_URL + 'companyNews/' + id + '/' + sessionStorage.getItem('cid'))
  }

  deleteCompanyNewsById(id: any) {
    return this.http.delete(this.base_URL + 'companyNews/hardDelete/' + id)
  }

  updateCompanyNews(body: any) {
    return this.http.put(this.base_URL + 'companyNews/update', body)
  }

  addPrivileges(body: any) {
    return this.http.post(this.base_URL + 'privileges', body)
  }

  getAllPrivileges() {
    return this.http.get(this.base_URL + 'privileges/all/' + sessionStorage.getItem('cid'))
  }

  getRolesByCreatedBy(userId: any) {
    return this.http.get(this.base_URL + 'roles/getRolesByCreatedBy/' + userId + "/" + sessionStorage.getItem('cid'))
  }

  getPrivilegeById(id: any) {
    return this.http.get(this.base_URL + 'privileges/' + id + '/' + sessionStorage.getItem('cid'))
  }

  deletePriviilege(id: any) {
    return this.http.delete(this.base_URL + 'privileges/hardDelete/' + id)
  }

  updatePrivilege(body: any) {
    return this.http.put(this.base_URL + 'privileges/update', body)
  }

  taskFilterByCreatedBetweenDates(pageNumber: any, recordsPerPage: any, startDate: any, endDate: any) {
    return this.http.get(this.base_URL + 'task/filterByCreatedBetweenDates/' + sessionStorage.getItem('cid') + '/{startDate}/{endDate}/' + pageNumber + '/' + recordsPerPage + '?startDate=' + startDate + '&endDate=' + endDate)
  }

  filterByCreatedBetweenDatesWithoutPagination(startDate: any, endDate: any) {
    return this.http.get(this.base_URL + 'task/filterByCreatedBetweenDatesWithoutPagination/{startDate}/{endDate}/' + sessionStorage.getItem('cid') + '/' + '?startDate=' + startDate + '&endDate=' + endDate)
  }

  taskFilterByAndUserIdAndDates(pageNumber: any, recordsPerPage: any, userId: any, startDate: any, endDate: any) {
    return this.http.get(this.base_URL + 'task/filterByAssignedToBetweenDates/' + sessionStorage.getItem('cid') + '/' + pageNumber + '/' + recordsPerPage + '/' + userId + '?startDate=' + startDate + '&endDate=' + endDate)
  }

  ticketFilterByAndUserIdAndDates(userId: any, startDate: any, endDate: any, pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'ticket/filterByAssignedToBetweenDates/' + sessionStorage.getItem('cid') + '/' + userId + '/' + pageNumber + '/' + recordsPerPage + '/' + '?startDate=' + startDate + '&endDate=' + endDate)
  }

  filterByTicketStatusAndBetweenDates(status: any, pageNumber: any, recordsPerPage: any, startDate: any, endDate: any) {
    return this.http.get(this.base_URL + 'ticket/filterByTicketStatusAndBetweenDates/' + sessionStorage.getItem('cid') + '/' + pageNumber + '/' + recordsPerPage + '?status=' + status + '&startDate=' + startDate + '&endDate=' + endDate)
  }

  filterByCustomerType(customerType: any, pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'ticket/getAllByCustomerType/' + customerType + "/" + sessionStorage.getItem('cid') + '/' + pageNumber + '/' + recordsPerPage)
  }

  ticketFilterByCreatedBetweenDates(pageNumber: any, recordsPerPage: any, startDate: any, endDate: any) {
    return this.http.get(this.base_URL + 'ticket/filterByCreatedBetweenDates/{startDate}/{endDate}/' + sessionStorage.getItem('cid') + '/' + pageNumber + '/' + recordsPerPage + '?startDate=' + startDate + '&endDate=' + endDate)
  }

  getAllTicketsByStatusAndBetweenUpdatedDates(status: any, pageNumber: any, recordsPerPage: any, startDate: any, endDate: any) {
    return this.http.get(this.base_URL + 'ticket/getAllTicketsByStatusAndBetweenUpdatedDates/' + sessionStorage.getItem('cid') + '/' + status + "/" + pageNumber + '/' + startDate + '/' + endDate + '/' + recordsPerPage)
  }

  filterByDates(pageNumber: any, recordsPerPage: any, startDate: any, endDate: any) {
    return this.http.get(this.base_URL + 'ticket/filterByDates/' + sessionStorage.getItem('cid') + '/' + pageNumber + '/' + recordsPerPage + "/?firstDate=" + startDate + "&secondDate=" + endDate)
  }

  getAllTicketsByCustomerPhoneNo(customerPhNo: any, pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'ticket/getAllTicketsByCustomerPhoneNo/' + customerPhNo + "/" + sessionStorage.getItem('cid') + '/' + pageNumber + '/' + recordsPerPage)
  }

  getAllByAssignedTo(assignedToId: any, pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'ticket/getAllByAssignedTo/' + assignedToId + "/" + sessionStorage.getItem('cid') + '/' + pageNumber + '/' + recordsPerPage)
  }

  filterByTaskAssignedToBetweenDates(userid: any, startDate: any, endDate: any) {
    return this.http.get(this.base_URL + 'task/filterByAssignedToBetweenDates/' + sessionStorage.getItem('cid') + '/' + userid + '?startDate=' + startDate + '&endDate=' + endDate)
  }

  ticketFilterByStatus(pageNumber: any, recordsPerPage: any, status: any) {
    return this.http.get(this.base_URL + 'ticket/filterByStatus/' + sessionStorage.getItem('cid') + '/' + pageNumber + '/' + recordsPerPage + '?status=' + status)
  }

  getAllTicketsByWildSearch(searchKey: any, pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'ticket/filterByWildSearch/' + sessionStorage.getItem('cid') + "/" + searchKey + '/' + pageNumber + '/' + recordsPerPage)
  }

  addSchedule(body: any) {
    return this.http.post(this.base_URL + 'schedule', body)
  }

  getAllSchedule() {
    return this.http.get(this.base_URL + 'schedule/all/' + sessionStorage.getItem('cid'))
  }

  getScheduleById(id: any) {
    return this.http.get(this.base_URL + 'schedule/' + id)
  }

  deleteSchedule(id: any) {
    return this.http.delete(this.base_URL + 'schedule/hardDelete/' + id)
  }

  updateSchedule(body: any) {
    return this.http.put(this.base_URL + 'schedule/update', body)
  }

  getAllUOMMasterByWildSearchWithoutPagination(wildSearch: any) {
    return this.http.get(this.base_URL + 'uomMaster/getAllUOMMasterByWildSearchWithoutPagination/' + wildSearch + "/" + sessionStorage.getItem('cid'))
  }

  addUomMaster(body: any) {
    return this.http.post(this.base_URL + 'uomMaster', body)
  }

  getAllUomMaster() {
    return this.http.get(this.base_URL + 'uomMaster/all/' + sessionStorage.getItem('cid'))
  }

  deleteUomMaster(id: any) {
    return this.http.delete(this.base_URL + 'uomMaster/hardDelete/' + id)
  }

  getUomMasterById(id: any) {
    return this.http.get(this.base_URL + 'uomMaster/' + id + '/' + sessionStorage.getItem('cid'))
  }

  updateUomMaster(body: any) {
    return this.http.put(this.base_URL + 'uomMaster/update', body)
  }

  addTicketTaskPriorityDefinition(body: any) {
    return this.http.post(this.base_URL + 'ticketTicketTaskPriorityDefinition', body)
  }

  updateTicketTaskPriorityDefinition(body: any) {
    return this.http.put(this.base_URL + 'ticketTicketTaskPriorityDefinition/update', body)
  }

  getTicketTaskPriorityDefinitionById(id: any) {
    return this.http.get(this.base_URL + 'ticketTicketTaskPriorityDefinition/' + id + '/' + sessionStorage.getItem('cid'))
  }

  getAllTicketTaskPriorityDefinitions() {
    return this.http.get(this.base_URL + 'ticketTicketTaskPriorityDefinition/all/' + sessionStorage.getItem('cid'))
  }

  deleteTicketTaskPriorityDefinition(id: any) {
    return this.http.delete(this.base_URL + 'ticketTicketTaskPriorityDefinition/softDelete/' + id)
  }

  getAllTicketTaskPriorityDefinitionByWildSearchWithoutPagination(wildSearch: any) {
    return this.http.get(this.base_URL + 'ticketTicketTaskPriorityDefinition/getByWildSearch/' + wildSearch + '/' + sessionStorage.getItem('cid'))
  }

  addTicketPriorityDefinition(body: any) {
    return this.http.post(this.base_URL + 'ticketPriorityDefinition', body)
  }

  getAllTicketPriorityDefinition() {
    return this.http.get(this.base_URL + 'ticketPriorityDefinition/all/' + sessionStorage.getItem('cid'))
  }

  deleteTicketPriorityDefinition(id: any) {
    return this.http.delete(this.base_URL + 'ticketPriorityDefinition/softDelete/' + id)
  }

  hardDeleteTicketPriorityDefinition(id: any) {
    return this.http.delete(this.base_URL + 'ticketPriorityDefinition/hardDelete/' + id)
  }

  getTicketPriorityDefinitionById(id: any) {
    return this.http.get(this.base_URL + 'ticketPriorityDefinition/' + id + '/' + sessionStorage.getItem('cid'))
  }

  updateTicketPriorityDefinition(body: any) {
    return this.http.put(this.base_URL + 'ticketPriorityDefinition/update', body)
  }

  addTaskPriorityDefinition(body: any) {
    return this.http.post(this.base_URL + 'taskPriorityDefinition', body)
  }

  getAllTaskPriorityDefinition() {
    return this.http.get(this.base_URL + 'taskPriorityDefinition/all/' + sessionStorage.getItem('cid'))
  }

  deleteTaskPriorityDefinition(id: any) {
    return this.http.delete(this.base_URL + 'taskPriorityDefinition/softDelete/' + id)
  }

  hardDeleteTaskPriorityDefinition(id: any) {
    return this.http.delete(this.base_URL + 'taskPriorityDefinition/hardDelete/' + id)
  }

  getTaskPriorityDefinitionById(id: any) {
    return this.http.get(this.base_URL + 'taskPriorityDefinition/' + id + '/' + sessionStorage.getItem('cid'))
  }

  updateTaskPriorityDefinition(body: any) {
    return this.http.put(this.base_URL + 'taskPriorityDefinition/update', body)
  }

  addStatusMaster(body: any) {
    return this.http.post(this.base_URL + 'statusInfo', body)
  }

  getAllStatusMaster() {
    return this.http.get(this.base_URL + 'statusInfo/all/' + sessionStorage.getItem('cid'))
  }

  deleteStatusMaster(id: any) {
    return this.http.delete(this.base_URL + 'statusInfo/hardDelete/' + id)
  }

  getStatusMasterById(id: any) {
    return this.http.get(this.base_URL + 'statusInfo/' + id + '/' + sessionStorage.getItem('cid'))
  }

  updateStatusMaster(body: any) {
    return this.http.put(this.base_URL + 'statusInfo/update', body)
  }

  postDynamicGet(body: any) {
    return this.http.post(this.base_URL + 'dynamicGetAll', body)
  }

  dynamicGetAllById(id: any) {
    return this.http.get(this.base_URL + 'dynamicGetAll/' + id + '/' + sessionStorage.getItem('cid'))
  }

  dynamicGetAll() {
    return this.http.get(this.base_URL + 'dynamicGetAll/all/' + sessionStorage.getItem('cid'))
  }

  getByApiName(name: any) {
    return this.http.get(this.base_URL + 'dynamicGetAll/getByApiName/' + sessionStorage.getItem('cid') + "/" + name)
  }

  updateDynamicGetAll(body: any) {
    return this.http.put(this.base_URL + 'dynamicGetAll/update', body)
  }

  deleteDynamicGetAll(id: any) {
    return this.http.delete(this.base_URL + 'dynamicGetAll/hardDelete/' + id)
  }

  addOffer(body: any) {
    return this.http.post(this.base_URL + 'offers', body)
  }

  getAllOffer() {
    return this.http.get(this.base_URL + 'offers/all/' + sessionStorage.getItem('cid'))
  }

  getOfferById(id: any) {
    return this.http.get(this.base_URL + 'offers/' + id + '/' + sessionStorage.getItem('cid'))
  }

  deleteOffer(id: any) {
    return this.http.delete(this.base_URL + 'offers/hardDelete/' + id)
  }

  updateOffer(body: any) {
    return this.http.put(this.base_URL + 'offers/update', body)
  }

  addCustomerInvoice(body: any) {
    return this.http.post(this.base_URL + 'customerInvoice', body)
  }



  getCustomerInvoiceById(id: any) {
    return this.http.get(this.base_URL + 'customerInvoice/' + id + '/' + sessionStorage.getItem('cid'))
  }

  getByInvoiceNo(invoice: any) {
    return this.http.get(this.base_URL + 'customerInvoice/getResponseBYInvoiceNo/' + invoice)
  }

  addCustomerPayment(body: any) {
    return this.http.post(this.base_URL + 'customerPayment', body)
  }

  getAllCustomerPayment() {
    return this.http.get(this.base_URL + 'customerPayment/all/' + sessionStorage.getItem('cid'))
  }

  getCustomerPaymentById(id: any) {
    return this.http.get(this.base_URL + 'customerPayment/' + id + '/' + sessionStorage.getItem('cid'))
  }

  addProductComposition(body: any) {
    return this.http.post(this.base_URL + 'productComposition', body)
  }

  getAllProductCompositionWithoutPagination() {
    return this.http.get(this.base_URL + 'productComposition/all/' + sessionStorage.getItem('cid'))
  }

  getAllProductComposition(pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'productComposition/all/' + sessionStorage.getItem('cid') + "/" + pageNumber + '/' + recordsPerPage)
  }

  getProductCompositionByWildSearch(searchKey: any, pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'productComposition/getByWildSearch/' + sessionStorage.getItem('cid') + "/" + searchKey + "/" + pageNumber + '/' + recordsPerPage)
  }

  deleteProductComposition(id: any) {
    return this.http.delete(this.base_URL + 'productComposition/hardDelete/' + id)
  }

  getProductCompositionById(id: any) {
    return this.http.get(this.base_URL + 'productComposition/' + id + '/' + sessionStorage.getItem('cid'))
  }

  updateProdcutComposition(body: any) {
    return this.http.put(this.base_URL + 'productComposition/update', body)
  }

  uploadImage(file: any) {
    let formData = new FormData();
    formData.append('file', file, file.name);
    return this.http.post(this.base_URL + 'upload-file/uploadFile?cid=' + sessionStorage.getItem('cid'), formData)
  }

  productMasterBulkUpload(file: any) {
    let formData = new FormData();
    formData.append('file', file, file.name);
    return this.http.post(this.base_URL + 'productMaster/bulkUpload', formData)
  }



  getUserActiveTask(id: any) {
    return this.http.get(this.base_URL + 'task/getUserActiveTask/' + sessionStorage.getItem('cid') + id)
  }

  getUserNonActiveTask(id: any) {
    return this.http.get(this.base_URL + 'task/getUserNonActiveTask/' + sessionStorage.getItem('cid') + id)
  }

  getAllActiveTask(pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'task/getAllActiveTask/' + sessionStorage.getItem('cid') + '/' + pageNumber + '/' + recordsPerPage)
  }

  getAllNonActiveTask(pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'task/getAllNonActiveTask/' + sessionStorage.getItem('cid') + '/' + pageNumber + '/' + recordsPerPage)
  }

  getAllWorkInProgressTickets(pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'ticket/getAllWorkInProgressTickets/' + sessionStorage.getItem('cid') + '/' + pageNumber + '/' + recordsPerPage)
  }

  customerInfoByMobile(mobile: any) {
    return this.http.get(this.base_URL + 'customerInfo/getAllByMobile/' + mobile)
  }

  customerInfoByEmail(email: any) {
    return this.http.get(this.base_URL + 'customerInfo/getAllByEmail/' + email)
  }

  getUsedUnusedServiceByEmailOrPhone(emailOrMobile: any) {
    return this.http.get(this.base_URL + 'customerPlanInfo/getUsedUnusedPlanByEmailOrPhone/' + emailOrMobile + "/" + sessionStorage.getItem('cid'))
  }

  addCustomerPlanInfo(body: any) {
    return this.http.post(this.base_URL + 'customerPlanInfo/addCustomerPlanInfo', body)
  }

  customerPlanInfo(body: any) {
    return this.http.post(this.base_URL + 'customerPlanInfo', body)
  }

  addCustomerAPK(body: any) {
    return this.http.post(this.base_URL + 'apkVersion', body)
  }

  getAllCustomerAPK() {
    return this.http.get(this.base_URL + 'apkVersion/all/' + sessionStorage.getItem('cid'))
  }

  getCustomerAPKById(id: any) {
    return this.http.get(this.base_URL + 'apkVersion/' + id + '/' + sessionStorage.getItem('cid'))
  }

  deleteCustomerAPK(id: any) {
    return this.http.delete(this.base_URL + 'apkVersion/hardDelete/' + id)
  }

  updateCustomerAPK(body: any) {
    return this.http.put(this.base_URL + 'apkVersion/update', body)
  }

  searchCustomer(key: any, pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'users/filterByWildSearch/' + sessionStorage.getItem('cid') + "/" + key + '/' + pageNumber + '/' + recordsPerPage)
  }

  getUserRoles() {
    return this.http.get(this.base_URL + 'users/getAllRoles/' + sessionStorage.getItem('cid'))
  }

  getSingleRoleById(roleId: any) {
    return this.http.get(this.base_URL + 'users/getRoleById/' + roleId)
  }

  getUserByType(type: any) {
    return this.http.get(this.base_URL + 'users/getAllByUserType/' + sessionStorage.getItem('cid') + "/" + type)
  }

  getAllByUserTypePaginated(type: any, pageNo: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'users/getAllByUserType/' + sessionStorage.getItem('cid') + "/" + type + "/" + pageNo + "/" + recordsPerPage)
  }

  getAllUsersByUserTypeForAnikiniTech(type: any, pageNo: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'users/getAllUsersByUserTypeForAnikiniTech/' + type + "/" + pageNo + "/" + recordsPerPage)
  }

  sendWhatsappMessageForScheduleDetail(body: any) {
    return this.http.post(this.base_URL + 'schedule/sendWhatsappMessageForScheduleDetail', body)
  }

  sendWhatsappMessageForLocationDetail(body: any) {
    return this.http.post(this.base_URL + 'schedule/sendWhatsappMessageForLocationDetail', body)
  }

  getActorsById(id: any) {
    return this.http.get(this.base_URL + 'schedule/getActorsById/' + id)
  }

  predefinedParameter(type: any) {
    return this.http.get(this.base_URL + 'predefinedParameter/getAllByType' + "/" + sessionStorage.getItem('cid') + "/" + type)
  }

  addDynamicSchedule(body: any) {
    return this.http.post(this.base_URL + 'dynamicSchedule', body)
  }

  getAllDynamicSchedule() {
    return this.http.get(this.base_URL + 'dynamicSchedule/all/' + sessionStorage.getItem('cid'))
  }

  getDynamicScheduleById(id: any) {
    return this.http.get(this.base_URL + 'dynamicSchedule/' + id + "/" + sessionStorage.getItem('cid'))
  }

  getByKeyAndValue(body: any) {
    return this.http.post(this.base_URL + 'marketingData/getByKeyAndValue/', body)
  }

  addObjectTypeAndGroup(body: any) {
    return this.http.post(this.base_URL + 'objectTypeAndGroupMaster', body)
  }

  getAllObjectTypeAndGroup() {
    return this.http.get(this.base_URL + 'objectTypeAndGroupMaster/getAll/' + sessionStorage.getItem('cid'))
  }

  getMarketingDataByPhone(phoneNumber: any) {
    return this.http.get(this.base_URL + 'marketingData/getByPhone/' + sessionStorage.getItem('cid') + "/" + phoneNumber)
  }

  getMarketingDataByName(name: any) {
    return this.http.get(this.base_URL + 'marketingData/getByName/' + sessionStorage.getItem('cid') + "/" + name)
  }

  getMarketingDataByLatestStatus(latestStatus: any) {
    return this.http.get(this.base_URL + 'marketingData/getByLatestStatus/' + sessionStorage.getItem('cid') + "/" + latestStatus)
  }

  getMarketingDataByEmail(email: any) {
    return this.http.get(this.base_URL + 'marketingData/getByEmail/' + sessionStorage.getItem('cid') + "/" + email)
  }

  getMarketingDataByUserIdAndDate(userId: any, date: any) {
    return this.http.get(this.base_URL + 'marketingData/getByUserIdAndDate/' + sessionStorage.getItem('cid') + "/" + userId + "/" + date)
  }

  getMarketingDataByGroup(group: any, type: any) {
    return this.http.get(this.base_URL + 'objectInfo/getAllByGroup/' + group + "/" + type + "/" + sessionStorage.getItem('cid'))
  }

  getAllAssetAuditInfoByFinancialYear(financialYear: any) {
    return this.http.get(this.base_URL + 'assetAuditInfo/getAllAssetAuditInfoByFinancialYear/' + financialYear + "/" + sessionStorage.getItem('cid'))
  }

  getAssetAuditInfoByAudited(isAudited: any, financialYear: any) {
    return this.http.get(this.base_URL + 'assetAuditInfo/getAssetAuditInfoByAudited/' + isAudited + "/" + financialYear + "/" + sessionStorage.getItem('cid'))
  }

  getAssetAuditReport(assetAuditReportId: any) {
    return this.http.get(this.base_URL + 'assetAuditReport/' + assetAuditReportId + "/" + sessionStorage.getItem('cid'))
  }


  updateAssetAuditInfo_Asset(body: any) {
    return this.http.put(this.base_URL + 'assetAuditInfo/updateAsset', body)
  }

  addAssetAuditReport(body: any) {
    return this.http.post(this.base_URL + 'assetAuditReport', body)
  }

  getAllAssetAuditReport() {
    return this.http.get(this.base_URL + 'assetAuditReport/all/' + sessionStorage.getItem('cid'))
  }

  addAssetAuditInfo(body: any) {
    return this.http.post(this.base_URL + 'assetAuditInfo', body)
  }

  getObjectInfoById(id: any) {
    return this.http.get(this.base_URL + 'objectInfo/' + id + "/" + sessionStorage.getItem('cid'))
  }

  updateObjectPerformanceMatrix(body: any) {
    return this.http.put(this.base_URL + 'objectInfo/updateObjectPerformanceMatrix', body)
  }

  getAllByAssetMonitoringAndCid(assetMonitoring: boolean) {
    return this.http.get(this.base_URL + 'objectInfo/getAllByAssetMonitoringAndCid/' + assetMonitoring + "/" + sessionStorage.getItem('cid'))
  }

  getPerformanceMatrixHistoryByObjectInfoId(objectId: any) {
    return this.http.get(this.base_URL + 'performanceMatrixHistory/' + objectId + "/" + sessionStorage.getItem('cid'))
  }

  getPerformanceMatrixHistoryByDate(dateAndTime: any) {
    return this.http.get(this.base_URL + 'performanceMatrixHistory/getPerformanceMatrixHistoryByDate/' + dateAndTime + "/" + sessionStorage.getItem('cid'))
  }

  getPerformanceMatrixHistoryByObjectIdAndDate(date: any, objectId: any) {
    return this.http.get(this.base_URL + 'performanceMatrixHistory/getPerformanceMatrixHistoryByObjectIdAndDate/' + date + "/" + objectId + "/" + sessionStorage.getItem('cid'))
  }


  getObjectInfoByType(type: any) {
    return this.http.get(this.base_URL + 'objectInfo/getAllByType/' + type + "/" + sessionStorage.getItem('cid'))
  }

  getObjectInfoByGroup(group: any) {
    return this.http.get(this.base_URL + 'objectInfo/getAllByGroup/' + group + "/" + sessionStorage.getItem('cid'))
  }

  getAllByLayerInfoId(id: any) {
    return this.http.get(this.base_URL + 'objectInfo/getAllByLayerInfoId/' + id + "/" + sessionStorage.getItem('cid'))
  }

  getAllObjectInfoByAllTemplateAndLocationsCounts(body: any) {
    return this.http.post(this.base_URL + 'objectInfo/getAllObjectInfoByAllTemplateAndLocationsCounts', body)
  }


  getObjectInfoByTemplateNameAndLocations(body: any) {
    return this.http.post(this.base_URL + 'objectInfo/getObjectInfoByTemplateNameAndLocations', body)
  }

  getAllObjectInfoByLocationsAndCid(body: any) {
    return this.http.post(this.base_URL + 'objectInfo/getAllObjectInfoByLocationsAndCid', body)
  }

  getAllObjectInfoWithPaginationAndLocation(body: any) {
    return this.http.post(this.base_URL + 'objectInfo/getAllObjectInfoWithPagination', body)
  }

  getAllObjectInfo() {
    return this.http.get(this.base_URL + 'objectInfo/all/' + sessionStorage.getItem('cid'))
  }

  updateObjectAliveRequest(body: any) {
    return this.http.put(this.base_URL + 'objectInfo/updateObjectAliveRequest', body)
  }

  getAllObjectInfoWithPagination(pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'objectInfo/getAllObjectInfoWithPagination/' + pageNumber + '/' + recordsPerPage)
  }

  updateObjectCondition(body: any) {
    return this.http.put(this.base_URL + 'objectInfo/updateObjectCondition', body)
  }

  updateObjectStatusRequest(body: any) {
    return this.http.put(this.base_URL + 'objectInfo/updateObjectStatusRequest', body)
  }

  getAllByHoldingUserIdAndCid(userId: any) {
    return this.http.get(this.base_URL + 'objectInfo/getAllByHoldingUserIdAndCid/' + userId + "/" + sessionStorage.getItem('cid'))
  }

  getObjectInfoByTemplateNameAndLocation(name: any, location: any) {
    return this.http.get(this.base_URL + 'objectInfo/getObjectInfoByTemplateNameAndLocation/' + name + "/" + location + "/" + sessionStorage.getItem('cid'))
  }


  getAllObjectInfoByAllTemplateCounts() {
    return this.http.get(this.base_URL + 'objectInfo/getAllObjectInfoByAllTemplateCounts/0')
  }

  getAssetRolloutByTemplateNameAndLocation(name: any, location: any) {
    return this.http.get(this.base_URL + 'assetRollout/getAssetRolloutByTemplateNameAndLocation/' + name + "/" + location)
  }

  getAssetRolloutByRolloutId(assetRolloutId: any) {
    return this.http.get(this.base_URL + 'assetRollout/' + assetRolloutId)
  }

  getAssetRolloutByObjectInfoId(objectInfoId: any) {
    return this.http.get(this.base_URL + 'assetRollout/getAssetRolloutByObjectInfoId/' + objectInfoId)
  }

  getObjectInfoByTemplateNameAndLocationAndAvailable(body: any) {
    return this.http.post(this.base_URL + 'objectInfo/getObjectInfoByTemplateNameAndLocationAndAvailable', body)
  }

  updateObjectImagesUpdateRequest(body: any) {
    return this.http.put(this.base_URL + 'objectInfo/updateObjectImagesUpdateRequest', body)
  }

  performanceMatrixHistory(body: any) {
    return this.http.post(this.base_URL + 'performanceMatrixHistory', body)
  }

  getObjectInfoByRepairExpectedEndDate(repairExpectedEndDate: any) {
    return this.http.get(this.base_URL + 'objectInfo/getObjectInfoByRepairExpectedEndDate/' + repairExpectedEndDate + "/" + sessionStorage.getItem('cid'))
  }

  getAllMaintenanceSchedulesByNextDueDate(nextDueDate: any) {
    return this.http.get(this.base_URL + 'maintenanceSchedule/getAllMaintenanceSchedulesByNextDueDate/' + nextDueDate + "/" + sessionStorage.getItem('cid'))
  }

  getAllMaintenanceSchedulesByWildSearch(wildSearch: any) {
    return this.http.get(this.base_URL + 'maintenanceSchedule/getAllMaintenanceSchedulesByWildSearch/' + wildSearch + "/" + sessionStorage.getItem('cid'))
  }

  getAllGivenRepairByAndCid(givenRepair: any) {
    return this.http.get(this.base_URL + 'objectInfo/getAllGivenRepairByAndCid/' + givenRepair + "/" + sessionStorage.getItem('cid'))
  }


  getAllMaintenanceSchedule() {
    return this.http.get(this.base_URL + 'maintenanceSchedule/all/' + sessionStorage.getItem('cid'))
  }

  getMaintenanceScheduleById(maintenanceScheduleId: any) {
    return this.http.get(this.base_URL + 'maintenanceSchedule/' + maintenanceScheduleId + "/" + sessionStorage.getItem('cid'))
  }

  deleteMaintenanceSchedule(id: any) {
    return this.http.delete(this.base_URL + 'maintenanceSchedule/hardDelete/' + id)
  }

  objectAllocationRegister(body: any) {
    return this.http.post(this.base_URL + 'objectAllocationRegister', body)
  }

  deleteObjectAllocationRegister(id: any) {
    return this.http.delete(this.base_URL + 'objectAllocationRegister/hardDelete/' + id)
  }

  updateStatusForAllocationRegister(objectAllocationRegisterId: any, body: any) {
    return this.http.put(this.base_URL + 'objectAllocationRegister/updateStatusForAllocationRegister/' + objectAllocationRegisterId + '/' + sessionStorage.getItem('cid'), body)
  }

  updateObjectAllocationRegisterForObjectsOnceAtATime(body: any) {
    return this.http.put(this.base_URL + 'objectAllocationRegister/updateObjectAllocationRegisterForObjectsOnceAtATime', body)
  }

  updateObjectAllocationRegisterForApproval(body: any) {
    return this.http.put(this.base_URL + 'objectAllocationRegister/updateObjectAllocationRegisterForApproval', body)
  }

  updateObjectAllocationRegisterForIssue(body: any) {
    return this.http.put(this.base_URL + 'objectAllocationRegister/updateObjectAllocationRegisterForIssue', body)
  }

  getAllObjectAllocationRegister() {
    return this.http.get(this.base_URL + 'objectAllocationRegister/all/' + sessionStorage.getItem('cid'))
  }

  getAllObjectAllocationRegisterWithPagination(body: any) {
    return this.http.post(this.base_URL + 'objectAllocationRegister/getAllObjectAllocationRegisterWithPagination', body)
  }


  getAllObjectAllocationRegisterGroupAndSolo() {
    return this.http.get(this.base_URL + 'objectAllocationRegister/getAllObjectAllocationRegisterGroupAndSolo')
  }

  deleteObjectAllocationRegisterGroup(id: any) {
    return this.http.delete(this.base_URL + 'objectAllocationRegisterGroup/hardDelete/' + id)
  }

  getAlObjectAllocationRegisterGroup() {
    return this.http.get(this.base_URL + 'objectAllocationRegisterGroup/all/' + sessionStorage.getItem('cid'))
  }

  getObjectAllocationRegisterGroupById(objectAllocationRegisterGroupId: any) {
    return this.http.get(this.base_URL + 'objectAllocationRegisterGroup/' + objectAllocationRegisterGroupId + "/" + sessionStorage.getItem('cid'))
  }

  getObjectAllocationRegisterByStatus(status: any) {
    return this.http.get(this.base_URL + 'objectAllocationRegister/getObjectAllocationRegisterByStatus/' + status + '/' + sessionStorage.getItem('cid'))
  }

  getAllObjectAllocationRegistersByWildSearch(wildSearch: any) {
    return this.http.get(this.base_URL + 'objectAllocationRegister/getAllObjectAllocationRegistersByWildSearch/' + wildSearch + "/" + sessionStorage.getItem('cid'))
  }


  getObjectAllocationRegisterByStatusWithPagination(body: any) {
    return this.http.post(this.base_URL + 'objectAllocationRegister/getObjectAllocationRegisterByStatusWithPagination', body)
  }
  getAllObjectAllocationRegistersByWildSearchWithPagination(body: any) {
    return this.http.post(this.base_URL + 'objectAllocationRegister/getAllObjectAllocationRegistersByWildSearchWithPagination', body)
  }

  getAllObjectAllocationRegistersByObjectId(objectId: any) {
    return this.http.get(this.base_URL + 'objectAllocationRegister/getAllObjectAllocationRegistersByObjectId/' + objectId + "/" + sessionStorage.getItem('cid'))
  }

  getObjectAllocationRegisterById(objectAllocationRegisterId: any) {
    return this.http.get(this.base_URL + 'objectAllocationRegister/' + objectAllocationRegisterId + "/" + sessionStorage.getItem('cid'))
  }

  deleteObjectInfo(id: any) {
    return this.http.delete(this.base_URL + 'objectInfo/hardDelete/' + id)
  }

  getAllModelByAndCid(model: any) {
    return this.http.get(this.base_URL + 'objectInfo/getAllModelByAndCid/' + model + "/" + sessionStorage.getItem('cid'))
  }

  getAllModelByAndCidWIthPagination(body: any) {
    return this.http.post(this.base_URL + 'objectInfo/getAllModelByAndCidWIthPagination', body)
  }

  getObjectInfoByParentAssetIdWithPagination(parentAssetId: any, pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'objectInfo/getObjectInfoByParentAssetIdWithPagination/' + parentAssetId + "/" + pageNumber + '/' + recordsPerPage)
  }

  getAllMakeByAndCid(make: any) {
    return this.http.get(this.base_URL + 'objectInfo/getAllMakeByAndCid/' + make + "/" + sessionStorage.getItem('cid'))
  }

  getAllMakeByAndCidWIthPagination(body: any) {
    return this.http.post(this.base_URL + 'objectInfo/getAllMakeByAndCidWIthPagination', body)
  }

  getAllByType(type: any) {
    return this.http.get(this.base_URL + 'objectInfo/getAllByType/' + type + "/" + sessionStorage.getItem('cid'))
  }

  getAllObjectInfoByTypeWithPagination(body: any) {
    return this.http.post(this.base_URL + 'objectInfo/getAllObjectInfoByTypeWithPagination', body)
  }

  getAllBySerialNumberAndCid(serialNumber: any) {
    return this.http.get(this.base_URL + 'objectInfo/getAllBySerialNumberAndCid/' + serialNumber + "/" + sessionStorage.getItem('cid'))
  }

  getAllBySerialNumberAndCidWithPagination(body: any) {
    return this.http.post(this.base_URL + 'objectInfo/getAllBySerialNumberAndCidWithPagination', body)
  }

  getAllByObjectConditionAndCid(objectCondition: any) {
    return this.http.get(this.base_URL + 'objectInfo/getAllByObjectConditionAndCid/' + objectCondition + "/" + sessionStorage.getItem('cid'))
  }

  getAllByObjectConditionAndCidWithPagination(body: any) {
    return this.http.post(this.base_URL + 'objectInfo/getAllByObjectConditionAndCidWithPagination', body)
  }

  getAllByBranchAndCid(branch: any) {
    return this.http.get(this.base_URL + 'objectInfo/getAllByBranchAndCid/' + branch + "/" + sessionStorage.getItem('cid'))
  }

  getAllByBranchAndCidWithPagination(body: any) {
    return this.http.post(this.base_URL + 'objectInfo/getAllByBranchAndCidWithPagination/{branch}/{pageNo}/{recordsPerPage}', body)
  }

  getAllByDepartmentAndCid(department: any) {
    return this.http.get(this.base_URL + 'objectInfo/getAllByDepartmentAndCid/' + department + "/" + sessionStorage.getItem('cid'))
  }

  getAllByDepartmentAndCidWithPagination(body: any) {
    return this.http.post(this.base_URL + 'objectInfo/getAllByDepartmentAndCidWithPagination/{department}/{pageNo}/{recordsPerPage}', body)
  }

  getAllByGroup(group: any) {
    return this.http.get(this.base_URL + 'objectInfo/getAllByGroup/' + group + "/" + sessionStorage.getItem('cid'))
  }

  getAllObjectInfoByGroupWithPagination(body: any) {
    return this.http.post(this.base_URL + 'objectInfo/getAllObjectInfoByGroupWithPagination', body)
  }

  getAllByLocationAndCid(location: any) {
    return this.http.get(this.base_URL + 'objectInfo/getAllByLocationAndCid/' + location + "/" + sessionStorage.getItem('cid'))
  }

  getAllByLocationAndCidWithPagination(location: any, pageNumber: any, recordsPerPage: any) {
    return this.http.post(this.base_URL + 'objectInfo/getAllByLocationAndCidWithPagination/' + location + "/" + pageNumber + '/' + recordsPerPage, '')
  }

  getAssetRolloutByLocation(location: any) {
    return this.http.get(this.base_URL + 'assetRollout/getAssetRolloutByLocation/' + location)
  }

  getAllObjectInfoByGroupAndType(group: any, type: any) {
    return this.http.get(this.base_URL + 'objectInfo/getAllObjectInfoByGroupAndType/' + group + "/" + type + "/" + sessionStorage.getItem('cid'))
  }

  deleteLayerInfo(id: any) {
    return this.http.delete(this.base_URL + 'layerInfo/hardDelete/' + id)
  }

  addMaintenanceSchedule(body: any) {
    return this.http.post(this.base_URL + 'maintenanceSchedule', body)
  }

  getAllMaintenanceScheduleByAssetId(assetId: any) {
    return this.http.get(this.base_URL + 'maintenanceSchedule/getAllMaintenanceScheduleByAssetId/' + assetId + "/" + sessionStorage.getItem('cid'))
  }

  getObjectInfoByWildSearch(wildSearch: any) {
    return this.http.get(this.base_URL + 'objectInfo/getObjectInfoByWildSearch/' + wildSearch + "/" + sessionStorage.getItem('cid'))
  }

  getObjectInfoByWildSearchWithPagination(body: any) {
    return this.http.post(this.base_URL + 'objectInfo/getObjectInfoByWildSearchWithPagination', body)
  }

  getObjectInfoByWildSearchAndGivenRepair(wildSearch: any, isRepairGiven: boolean) {
    return this.http.get(this.base_URL + 'objectInfo/getObjectInfoByWildSearchAndGivenRepair/' + wildSearch + "/" + isRepairGiven + "/" + sessionStorage.getItem('cid'))
  }

  getAllObjectsByLockAndCid(lock: any) {
    return this.http.get(this.base_URL + 'objectInfo/getAllObjectsByLockAndCid/' + lock + "/" + sessionStorage.getItem('cid'))
  }

  getAllObjectsByLockAndCidWithPagination(body: any) {
    return this.http.post(this.base_URL + 'objectInfo/getAllObjectsByLockAndCidWithPagination', body)
  }

  updateObjectInfoLocking(body: any) {
    return this.http.put(this.base_URL + 'objectInfo/updateObjectInfoLocking', body)
  }

  syncPorts(objectInfoId: any) {
    return this.http.post(this.base_URL + 'objectInfo/' + objectInfoId + '/sync-ports', '')
  }

  hostGroups() {
    return this.http.get(this.base_URL + 'zabbix/hostGroups')
  }

  getTemplates() {
    return this.http.get(this.base_URL + 'zabbix/getTemplates')
  }

  getHostById(hostId: any) {
    return this.http.get(this.base_URL + 'zabbix/getHostById/' + hostId)
  }

  addHost(body: any) {
    return this.http.post(this.base_URL + 'zabbix/add-host', body)
  }

  addObjectInfo(body: any) {
    return this.http.post(this.base_URL + 'objectInfo', body)
  }

  updateObjectHolding(body: any) {
    return this.http.put(this.base_URL + 'objectInfo/updateObjectHoldingRequest', body)
  }

  insertMultipleObjectInfos(body: any) {
    return this.http.post(this.base_URL + 'objectInfo/insertMultipleObjectInfos', body)
  }

  updateBulkObjectLatLngRequest(body: any) {
    return this.http.put(this.base_URL + 'objectInfo/updateBulkObjectLatLngRequest', body)
  }

  getAllObjectInfoCounts() {
    return this.http.get(this.base_URL + 'objectInfo/getAllObjectInfoCounts/' + sessionStorage.getItem('cid'))
  }

  updateObjectInfo(body: any) {
    return this.http.put(this.base_URL + 'objectInfo/update', body)
  }

  updateObjectInfoByRepairInfo(body: any) {
    return this.http.put(this.base_URL + 'objectInfo/updateObjectInfoByRepairInfo', body)
  }

  getAllClientJob() {
    return this.http.get(this.base_URL + 'clientJob/all/' + sessionStorage.getItem('cid'))
  }

  addClientJob(body: any) {
    return this.http.post(this.base_URL + 'clientJob', body)
  }

  updateClientJob(body: any) {
    return this.http.put(this.base_URL + 'clientJob/update', body)
  }

  getClientJobById(id: any) {
    return this.http.get(this.base_URL + 'clientJob/' + id)
  }

  deleteClientJob(id: any) {
    return this.http.delete(this.base_URL + 'clientJob/hardDelete/' + id)
  }

  addCProduct(body: any) {
    return this.http.post(this.base_URL + 'cproductMaster', body)
  }

  editCProduct(body: any) {
    return this.http.put(this.base_URL + 'cproductMaster/update', body)
  }

  getCproductMasterById(id: any) {
    return this.http.get(this.base_URL + 'cproductMaster/' + id + "/" + sessionStorage.getItem('cid'))
  }

  getAllcProductMaster() {
    return this.http.get(this.base_URL + 'cproductMaster/allCProductMasterByCid/' + sessionStorage.getItem('cid'))
  }

  getAllcProductMasterWithPagination(pageNo: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'cproductMaster/all/' + sessionStorage.getItem('cid') + '/' + pageNo + '/' + recordsPerPage)
  }

  getCProductMasterByWildSearch(body: any) {
    return this.http.post(this.base_URL + 'cproductMaster/getByWildSearch', body)
  }

  deleteCproductMaster(id: any) {
    return this.http.delete(this.base_URL + 'cproductMaster/hardDelete/' + id)
  }

  addMaterialCharge(body: any) {
    return this.http.post(this.base_URL + 'materialCharge', body)
  }

  getAllMaterialCharge() {
    return this.http.get(this.base_URL + 'materialCharge/all/' + sessionStorage.getItem('cid'))
  }

  addUomConversion(body: any) {
    return this.http.post(this.base_URL + 'uomConversion', body)
  }

  getAllUomConversion() {
    return this.http.get(this.base_URL + 'uomConversion/all/' + sessionStorage.getItem('cid'))
  }

  getAllUomConversionWithPagination(pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'uomConversion/all/' + sessionStorage.getItem('cid') + '/' + pageNumber + '/' + recordsPerPage)
  }


  getAllUOMByWildSearch(key: any, pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'uomConversion/getAllUOMByWildSearch/' + key + "/" + sessionStorage.getItem('cid') + '/' + pageNumber + '/' + recordsPerPage)
  }

  deleteUomConversion(id: any) {
    return this.http.delete(this.base_URL + 'uomConversion/hardDelete/' + id)
  }

  addBatchInfo(body: any) {
    return this.http.post(this.base_URL + 'batchInfo', body)
  }

  editBatchInfo(body: any) {
    return this.http.put(this.base_URL + 'batchInfo/update', body)
  }

  getAllBatchInfo() {
    return this.http.get(this.base_URL + 'batchInfo/all/' + sessionStorage.getItem('cid'))
  }

  getBatchInfoById(id: any) {
    return this.http.get(this.base_URL + 'batchInfo/' + id + "/" + sessionStorage.getItem('cid'))
  }

  getBatchInfoByWildSearch(wildSearch: any, cid?: any) {
    let companyId = cid ? cid : sessionStorage.getItem('cid');
    return this.http.get(this.base_URL + 'batchInfo/getBatchInfoByWildSearch/' + wildSearch + "/" + companyId);
  }

  deleteBatchInfo(id: any) {
    return this.http.delete(this.base_URL + 'batchInfo/hardDelete/' + id)
  }

  calculateConPrice(baseUOM: any, conUOM: any, basePrice: any) {
    return this.http.get(this.base_URL + 'uomConversion/calculateConPrice/' + baseUOM + '/' + conUOM + '/' + basePrice + "/" + sessionStorage.getItem('cid'))
  }

  addProductDisplayZone(body: any) {
    return this.http.post(this.base_URL + 'productDisplayZone', body)
  }

  getAllProductDisplayZone() {
    return this.http.get(this.base_URL + 'productDisplayZone/all/' + sessionStorage.getItem('cid'))
  }

  editProductDisplayZone(body: any) {
    return this.http.put(this.base_URL + 'productDisplayZone/update', body)
  }

  getProductDisplayZoneById(id: any) {
    return this.http.get(this.base_URL + 'productDisplayZone/' + id + "/" + sessionStorage.getItem('cid'))
  }

  deleteProductDisplayZone(id: any) {
    return this.http.delete(this.base_URL + 'productDisplayZone/hardDelete/' + id)
  }

  generate2StepAuthenticationKey(mobile: any) {
    return this.http.get(this.base_URL + 'users/generate2StepAuthenticationKey/' + mobile + "/" + sessionStorage.getItem('cid'))
  }

  addBannerZone(body: any) {
    return this.http.post(this.base_URL + 'bannerZone', body)
  }

  getAllBannerZone() {
    return this.http.get(this.base_URL + 'bannerZone/all/' + sessionStorage.getItem('cid'))
  }

  getBannerZoneById(id: any) {
    return this.http.get(this.base_URL + 'bannerZone/' + id + "/" + sessionStorage.getItem('cid'))
  }

  deleteBannerZone(id: any) {
    return this.http.delete(this.base_URL + 'bannerZone/hardDelete/' + id)
  }

  editBannerZone(body: any) {
    return this.http.put(this.base_URL + 'bannerZone/update', body)
  }

  getAllProductCategory() {
    return this.http.get(this.base_URL + 'productCategory/all/' + sessionStorage.getItem('cid'))
  }

  getProductCategoryById(id: any) {
    return this.http.get(this.base_URL + 'productCategory/' + id + "/" + sessionStorage.getItem('cid'))
  }

  addProductCategory(body: any) {
    return this.http.post(this.base_URL + 'productCategory', body)
  }

  deleteProductCategory(id: any) {
    return this.http.delete(this.base_URL + 'productCategory/hardDelete/' + id)
  }

  editProductCategory(body: any) {
    return this.http.put(this.base_URL + 'productCategory/update', body)
  }

  getAllTaxMaster() {
    return this.http.get(this.base_URL + 'taxMaster/all/' + sessionStorage.getItem('cid'))
  }

  getAllTaxMasterWithPagination(pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'taxMaster/all/' + sessionStorage.getItem('cid') + '/' + pageNumber + '/' + recordsPerPage)
  }

  getAllTaxMasterByWildSearch(searchKey: any, pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'taxMaster/all/' + sessionStorage.getItem('cid') + "/" + searchKey + '/' + pageNumber + '/' + recordsPerPage)
  }

  getTaxMasterById(id: any) {
    return this.http.get(this.base_URL + 'taxMaster/' + id + "/" + sessionStorage.getItem('cid'))
  }

  addTaxMaster(body: any) {
    return this.http.post(this.base_URL + 'taxMaster', body)
  }

  deleteTaxMaster(id: any) {
    return this.http.delete(this.base_URL + 'taxMaster/hardDelete/' + id)
  }

  editTaxMaster(body: any) {
    return this.http.put(this.base_URL + 'taxMaster/update', body)
  }

  getAllSurveyTemplate() {
    return this.http.get(this.base_URL + 'surveyTemplate/all/' + sessionStorage.getItem('cid'))
  }

  getSurveyTemplate(id: any) {
    return this.http.get(this.base_URL + 'surveyTemplate/' + id + "/" + sessionStorage.getItem('cid'))
  }

  addSurveyTemplate(body: any) {
    return this.http.post(this.base_URL + 'surveyTemplate', body)
  }

  deleteSurveyTemplate(id: any) {
    return this.http.delete(this.base_URL + 'surveyTemplate/hardDelete/' + id)
  }

  editSurveyTemplate(body: any) {
    return this.http.put(this.base_URL + 'surveyTemplate/update', body)
  }

  getAllCart() {
    return this.http.get(this.base_URL + 'myCart/all/' + sessionStorage.getItem('cid'))
  }

  getCartById(cartId: any) {
    return this.http.get(this.base_URL + 'myCart/' + cartId + '/' + sessionStorage.getItem('cid'))
  }

  getAllWishList() {
    return this.http.get(this.base_URL + 'wishList/all/' + sessionStorage.getItem('cid'))
  }

  getWishListById(wishListId: any) {
    return this.http.get(this.base_URL + 'wishList/' + wishListId + '/' + sessionStorage.getItem('cid'))
  }

  addProductMasterGroup(body: any) {
    return this.http.post(this.base_URL + 'productMasterGroup', body)
  }

  getAllProductMasterGroup() {
    return this.http.get(this.base_URL + 'productMasterGroup/all/' + sessionStorage.getItem('cid'))
  }

  getAllProductMasterGroupWithPagination(pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'productMasterGroup/all/' + sessionStorage.getItem('cid') + '/' + pageNumber + '/' + recordsPerPage)
  }

  getAllProductMasterGroupByWildSearch(searchKey: any, pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'productMasterGroup/getByWildSearch/' + searchKey + "/" + sessionStorage.getItem('cid') + '/' + pageNumber + '/' + recordsPerPage)
  }

  getProductMasterGroupById(id: any) {
    return this.http.get(this.base_URL + 'productMasterGroup/' + id + '/' + sessionStorage.getItem('cid'))
  }

  deleteProductMasterGroup(id: any) {
    return this.http.delete(this.base_URL + 'productMasterGroup/hardDelete/' + id)
  }

  updateProductMasterGroup(body: any) {
    return this.http.put(this.base_URL + 'productMasterGroup/update', body)
  }

  addTendor(body: any) {
    return this.http.post(this.base_URL + 'tendorInfo', body)
  }

  getAllTendor(pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'tendorInfo/all/' + sessionStorage.getItem('cid') + '/' + pageNumber + '/' + recordsPerPage)
  }

  getTendorById(id: any) {
    return this.http.get(this.base_URL + 'tendorInfo/' + id + '/' + sessionStorage.getItem('cid'))
  }

  getAllTendorByStatus(status: any, pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'tendorInfo/getAllByStatus/' + status + "/" + sessionStorage.getItem('cid') + '/' + pageNumber + '/' + recordsPerPage)
  }

  deleteTendorInfo(id: any) {
    return this.http.delete(this.base_URL + 'tendorInfo/hardDelete/' + id)
  }

  insertTendorApplication(body: any) {
    return this.http.post(this.base_URL + 'tendorInfo/insertTendorApplication', body)
  }

  getAllTendorApplicaitonByTendorInfoId(id: any) {
    return this.http.get(this.base_URL + 'tendorInfo/getAllTendorApplicaitonByTendorInfoId/' + id + '/' + sessionStorage.getItem('cid'))
  }

  getVendorByPhone(emailOrMobile: any) {
    return this.http.get(this.base_URL + 'vendorMaster/getVendorByPhone/' + emailOrMobile + "/" + sessionStorage.getItem('cid'))
  }

  getTendorApplicaitonById(id: any) {
    return this.http.get(this.base_URL + 'tendorInfo/getTendorApplicaitonById/' + id + '/' + sessionStorage.getItem('cid'))
  }

  addTendorApplicatoinReview(body: any) {
    return this.http.put(this.base_URL + 'tendorInfo/addTendorApplicatoinReview', body)
  }

  addTendorApplicatoinReport(body: any) {
    return this.http.put(this.base_URL + 'tendorInfo/addTendorApplicatoinReport', body)
  }

  updateTendorApplicatoinStatus(tendorApplicationId: any, body: any) {
    return this.http.put(this.base_URL + 'tendorInfo/updateTendorApplicatoinStatus/' + tendorApplicationId, body)
  }

  getAllTendorApplicaitonByTendorInfoIdAndLatestStatus(id: any, status: any) {
    return this.http.get(this.base_URL + 'tendorInfo/getAllTendorApplicaitonByTendorInfoIdAndLatestStatus/' + id + '/' + status + '/' + sessionStorage.getItem('cid'))
  }

  getAllTendorInfoByWildSearchAndSearchFieldName(keyword: any, searchFieldName: any) {
    return this.http.get(this.base_URL + 'tendorInfo/getAllTendorInfoByWildSearchAndSearchFieldName/' + keyword + '/' + searchFieldName + '/' + sessionStorage.getItem('cid'))
  }


  tendorTicket(body: any) {
    return this.http.post(this.base_URL + 'tendorTicket', body)
  }

  getAllTendorTicket() {
    return this.http.get(this.base_URL + 'tendorTicket/all/' + sessionStorage.getItem('cid'))
  }

  getTendorTicketById(id: any) {
    return this.http.get(this.base_URL + 'tendorTicket/' + id + '/' + sessionStorage.getItem('cid'))
  }

  getAllTendorTicketsByTendorInfoId(id: any) {
    return this.http.get(this.base_URL + 'tendorTicket/getAllTendorTicketsByTendorInfoId/' + id + '/' + sessionStorage.getItem('cid'))
  }

  getAllExistingCustomerInfo() {
    return this.http.get(this.base_URL + 'existingCustomerInfo/all/' + sessionStorage.getItem('cid'))
  }

  getExistingCustomerById(id: any) {
    return this.http.get(this.base_URL + 'existingCustomerInfo/' + id + '/' + sessionStorage.getItem('cid'))
  }

  updateExistingCustomerInfoStatus(body: any) {
    return this.http.put(this.base_URL + 'existingCustomerInfo/updateStatus', body)
  }

  updateExistingCustomerInfo(body: any) {
    return this.http.put(this.base_URL + 'existingCustomerInfo/update', body)
  }

  getExistingCustomerByMobile(mobile: any) {
    return this.http.get(this.base_URL + 'existingCustomerInfo/getByMobile/' + mobile + '/' + sessionStorage.getItem('cid'))
  }

  getExistingCustomerByEmail(email: any) {
    return this.http.get(this.base_URL + 'existingCustomerInfo/getByMobile/' + email + '/' + sessionStorage.getItem('cid'))
  }

  getExistingCustomerByDeviceId(deviceId: any) {
    return this.http.get(this.base_URL + 'existingCustomerInfo/getByMobile/' + deviceId + '/' + sessionStorage.getItem('cid'))
  }

  getExistingCustomerByStatus(status: any) {
    return this.http.get(this.base_URL + 'existingCustomerInfo/getAllByStatus/' + status + '/' + sessionStorage.getItem('cid'))
  }

  getAllPropTradeEnquiry() {
    return this.http.get(this.base_URL + 'propTradeEnquiry/all/' + sessionStorage.getItem('cid'))
  }

  deletePropTradeEnquiry(id: any) {
    return this.http.delete(this.base_URL + 'propTradeEnquiry/hardDelete/' + id)
  }

  getUserTypeWiseUserCount(startDate: any, endDate: any) {
    return this.http.get(this.base_URL + 'dashboard1/getUserTypeWiseUserCount' + '/' + sessionStorage.getItem('cid') + '/' + startDate + '/' + endDate)
  }

  getAssignedToAndLatestStatusWiseCountByCidAndDates(startDate: any, endDate: any) {
    return this.http.get(this.base_URL + 'dashboard1/getAssignedToAndLatestStatusWiseCountByCidAndDates' + '/' + sessionStorage.getItem('cid') + '/' + startDate + '/' + endDate)
  }


  updateTicketPriority(ticketId: any, ticketPriority: any) {
    return this.http.put(this.base_URL + 'ticket/updateTicketPriority/' + ticketId + '/' + sessionStorage.getItem('cid') + '/' + ticketPriority, {})
  }

  updateTaskPriority(taskId: any, taskPriority: any) {
    return this.http.put(this.base_URL + 'task/updateTaskPriority/' + taskId + '/' + sessionStorage.getItem('cid') + '/' + taskPriority, {})
  }

  addIdistributor(body: any) {
    return this.http.post(this.base_URL + 'idistributor', body)
  }

  getAllIdistributor(pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'idistributor/all/' + sessionStorage.getItem('cid') + '/' + pageNumber + '/' + recordsPerPage)
  }

  getIdistributorById(IdistributorId: any) {
    return this.http.get(this.base_URL + 'idistributor/' + IdistributorId + '/' + sessionStorage.getItem('cid'))
  }

  idistributorUpdateStatus(body: any) {
    return this.http.put(this.base_URL + 'idistributor/update_status', body)
  }

  addIdealer(body: any) {
    return this.http.post(this.base_URL + 'idealer', body)
  }

  idealerUpdateStatus(body: any) {
    return this.http.put(this.base_URL + 'idealer/update_status', body)
  }

  getAllIdealer(pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'idealer/all/' + sessionStorage.getItem('cid') + '/' + pageNumber + '/' + recordsPerPage)
  }

  getAllIDealerWithoutPagination() {
    return this.http.get(this.base_URL + 'idealer/getAllIDealerWithoutPagination/' + sessionStorage.getItem('cid'))
  }


  getIdealerById(IdealerId: any) {
    return this.http.get(this.base_URL + 'idealer/' + IdealerId + '/' + sessionStorage.getItem('cid'))
  }

  getIDealerByDistributorId(iDistributorId: any, pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'idealer/getIDealerByDistributorId/' + iDistributorId + "/" + sessionStorage.getItem('cid') + '/' + pageNumber + '/' + recordsPerPage)
  }

  deleteIdealer(id: any) {
    return this.http.delete(this.base_URL + 'idealer/hardDelete/' + id)
  }


  getAllTaskCountForTechnician() {
    return this.http.get(this.base_URL + 'task/getAllTaskCountForTechnician/' + sessionStorage.getItem('cid'))
  }


  msg91WhatsappSendTicketConversation(body: any) {
    return this.http.post(this.base_URL + 'msg91/whatsapp/send-ticket-conversation', body)
  }




  deleteClientDocs(id: any) {
    return this.http.delete(this.base_URL + 'clientDocs/hardDelete/' + id)
  }

  getFolderPathForGivenFolder(parentFolderId: String, clientDocsId: any) {
    return this.http.get(this.base_URL + 'clientDocs/getFolderPathForGivenFolder/' + parentFolderId + "/" + clientDocsId + "/" + sessionStorage.getItem('cid'))

    // let api: any
    // let hasHash = ""
    // if(parentFolderId.includes('#')){
    //   hasHash = "#"
    //   api = parentFolderId.split("#");
    //   console.log('has')
    // }else{
    //   hasHash = ""
    //   console.log('no')

    // }
    // console.log(api)
    // console.log(hasHash)
    // if(hasHash != ''){
    //   return this.http.get(this.base_URL+'clientDocs/getFolderHierarchyByParentFolderId/'+api[0]+"#"+api[1]+"/"+clientDocsId+"/"+sessionStorage.getItem('cid'))
    // }else{
    //   return this.http.get(this.base_URL+'clientDocs/getFolderHierarchyByParentFolderId/'+parentFolderId+"/"+clientDocsId+"/"+sessionStorage.getItem('cid'))
    // }



  }


  getFolderHierarchyByParentFolderId(parentFolderId: String, clientDocsId: any) {
    return this.http.get(this.base_URL + 'clientDocs/getFolderHierarchyByParentFolderId/' + parentFolderId + "/" + clientDocsId + "/" + sessionStorage.getItem('cid'))
  }

  clientDocsRename(body: any) {
    return this.http.put(this.base_URL + 'clientDocs/rename', body)
  }

  moveClientDocs(body: any) {
    return this.http.put(this.base_URL + 'clientDocs/moveClientDocs', body)
  }

  copyClientDocs(body: any) {
    return this.http.put(this.base_URL + 'clientDocs/copyClientDocs', body)
  }

  allClientDocsAtZeroLevel() {
    return this.http.get(this.base_URL + 'clientDocs/allClientDocsAtZeroLevel/' + sessionStorage.getItem('cid'))
  }

  getTagSearchForClientDocs(tagName: any) {
    return this.http.get(this.base_URL + 'tag_search_for_client_docs/' + tagName + "/" + sessionStorage.getItem('cid'))
  }

  getMetaDataSearchForClientDocs(metaDataName: any) {
    return this.http.get(this.base_URL + 'meta_data_search_for_client_docs/' + metaDataName + "/" + sessionStorage.getItem('cid'))
  }

  getCreatedDateForClientDocs(createdDate: any) {
    return this.http.get(this.base_URL + 'created_date_for_client_docs/' + createdDate + "/" + sessionStorage.getItem('cid'))
  }

  getAllTagSearchForClientDocs() {
    return this.http.get(this.base_URL + 'tag_search_for_client_docs/all/' + sessionStorage.getItem('cid'))
  }

  deleteSubfolder(clientDocsId: any, id: any) {
    return this.http.delete(this.base_URL + 'clientDocs/deleteSubfolder/' + clientDocsId + "/" + id + "/" + sessionStorage.getItem('cid'))
  }


  addClientDocs(body: any) {
    return this.http.post(this.base_URL + 'clientDocs', body)
  }

  getAllClientDocs(pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'clientDocs/all/' + sessionStorage.getItem('cid') + '/' + pageNumber + '/' + recordsPerPage)
  }

  getClientDocByClientDocId(clientDocsId: any) {
    return this.http.get(this.base_URL + 'clientDocs/' + clientDocsId + "/" + sessionStorage.getItem('cid'))
  }

  addFiles(body: any) {
    return this.http.post(this.base_URL + 'clientDocs/addFiles', body)
  }

  addAccessPrivilegesRequest(body: any) {
    return this.http.post(this.base_URL + 'clientDocs/addAccessPrivilegesRequest/', body)
  }

  updateAccessPrivilegesRequest(body: any) {
    return this.http.put(this.base_URL + 'clientDocs/updateAccessPrivilegesRequest/', body)
  }

  getAllAccessPrivilegesRequests() {
    return this.http.get(this.base_URL + 'clientDocs/getAllAccessPrivilegesRequests/' + sessionStorage.getItem('cid'))
  }

  getAccessPrivilegesRequestByRequestId(requestId: any) {
    return this.http.get(this.base_URL + 'clientDocs/getAccessPrivilegesRequestByRequestId/' + requestId + "/" + sessionStorage.getItem('cid'))
  }

  addLayerInfo(body: any) {
    return this.http.post(this.base_URL + 'layerInfo', body)
  }

  getAllLayerInfo() {
    return this.http.get(this.base_URL + 'layerInfo/all/' + sessionStorage.getItem('cid'))
  }

  getLayerInfoByLayerInfoId(layerInfoId: any) {
    return this.http.get(this.base_URL + 'layerInfo/' + layerInfoId + "/" + sessionStorage.getItem('cid'))
  }


  addCustomerProductPrice(body: any) {
    return this.http.post(this.base_URL + 'customerProductPrice', body)
  }

  updateCustomerProductPrice(body: any) {
    return this.http.put(this.base_URL + 'customerProductPrice/update', body)
  }

  getAllCustomerProductPrice(pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'customerProductPrice/all/' + sessionStorage.getItem('cid') + '/' + pageNumber + '/' + recordsPerPage)
  }

  getCustomerProductPriceByCustomerProductPriceId(customerProductPriceId: String) {
    return this.http.get(this.base_URL + 'customerProductPrice/' + customerProductPriceId + "/" + sessionStorage.getItem('cid'))
  }

  deleteCustomerProductPrice(id: any) {
    return this.http.delete(this.base_URL + 'customerProductPrice/hardDelete/' + id)
  }

  addObjectGroup(body: any) {
    return this.http.post(this.base_URL + 'objectGroupMaster', body)
  }

  addObjectTypeMaster(body: any) {
    return this.http.post(this.base_URL + 'objectTypeMaster', body)
  }

  getAllTypeList() {
    return this.http.get(this.base_URL + 'objectTypeMaster/getAllTypeList/' + sessionStorage.getItem('cid'))
  }

  getAllTypeByWildSearch(wildSearch: any) {
    return this.http.get(this.base_URL + 'objectTypeMaster/getAllTypeByWildSearch/' + wildSearch + "/" + sessionStorage.getItem('cid'))
  }

  deleteObjectTypeMaster(id: any) {
    return this.http.delete(this.base_URL + 'objectTypeMaster/hardDelete/' + id)
  }

  getAllGroupList() {
    return this.http.get(this.base_URL + 'objectGroupMaster/getAllGroupList/' + sessionStorage.getItem('cid'))
  }

  getAllGroupListByCid(cid: any) {
    return this.http.get(this.base_URL + 'objectGroupMaster/getAllGroupList/' + cid)
  }

  getAllGroupByWildSearch(wildSearch: any) {
    return this.http.get(this.base_URL + 'objectGroupMaster/getAllGroupByWildSearch/' + wildSearch + "/" + sessionStorage.getItem('cid'))
  }

  deleteObjectGroupMaster(id: any) {
    return this.http.delete(this.base_URL + 'objectGroupMaster/hardDelete/' + id)
  }

  getCompanyProfile(pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'companyProfile/all/' + sessionStorage.getItem('cid') + '/' + pageNumber + '/' + recordsPerPage)
  }

  getAllCompanyProfileWithoutPagination() {
    return this.http.get(this.base_URL + 'companyProfile/allWithoutPagination/' + sessionStorage.getItem('cid'))
  }

  getAllLocation() {
    return this.http.get(this.base_URL + 'location/all/' + sessionStorage.getItem('cid'))
  }

  getAllLocationByCid(cid: any) {
    return this.http.get(this.base_URL + 'location/all/' + cid)
  }

  getLocationById(locationId: any) {
    return this.http.get(this.base_URL + 'location/' + locationId + '/' + sessionStorage.getItem('cid'))
  }

  getAllIndustry() {
    return this.http.get(this.base_URL + 'industry/all/' + sessionStorage.getItem('cid'))
  }

  ttd_seva(body: any) {
    return this.http.post(this.base_URL + 'ttd_seva', body)
  }

  getAllTtd_seva() {
    return this.http.get(this.base_URL + 'ttd_seva/all/' + sessionStorage.getItem('cid'))
  }

  get_ttd_sevaById(tTDSevaId: any) {
    return this.http.get(this.base_URL + 'ttd_seva/' + tTDSevaId + '/' + sessionStorage.getItem('cid'))
  }

  updateTTDSevaStatus(tTdId: any, body: any) {
    return this.http.put(this.base_URL + 'ttd_seva/updateTTDSevaStatus/' + tTdId + "/" + sessionStorage.getItem('cid'), body)
  }

  addTempleInfo(body: any) {
    return this.http.post(this.base_URL + 'temple_info', body)
  }

  getAllTemple_info() {
    return this.http.get(this.base_URL + 'temple_info/all/' + sessionStorage.getItem('cid'))
  }

  getTemple_infoById(templeInfoId: any) {
    return this.http.get(this.base_URL + 'temple_info/' + templeInfoId + '/' + sessionStorage.getItem('cid'))
  }

  addUserQuotas(body: any) {
    return this.http.post(this.base_URL + 'user_quotas', body)
  }

  getAllUserQuotas() {
    return this.http.get(this.base_URL + 'user_quotas/all/' + sessionStorage.getItem('cid'))
  }

  getUserQuotasIdById(userQuotasId: any) {
    return this.http.get(this.base_URL + 'user_quotas/' + userQuotasId + '/' + sessionStorage.getItem('cid'))
  }

  addWhatsappTemplate(body: any) {
    return this.http.post(this.base_URL + 'whatsapp-template', body)
  }

  getAllWhatsappTemple() {
    return this.http.get(this.base_URL + 'whatsapp-template/all/' + sessionStorage.getItem('cid'))
  }



  getPackagingNotDoneInvoices(pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'customerInvoice/getPackagingNotDoneInvoices/' + sessionStorage.getItem('cid') + "/" + pageNumber + '/' + recordsPerPage)
  }

  getCustomerInvoiceByDeliveryReadyStatus(pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'customerInvoice/getCustomerInvoiceByDeliveryReadyStatus/YES/' + sessionStorage.getItem('cid') + "/" + pageNumber + '/' + recordsPerPage)
  }

  getAllCustomerInvoice(pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'customerInvoice/all/' + sessionStorage.getItem('cid') + "/" + pageNumber + '/' + recordsPerPage)
  }

  insertEComTicket(body: any) {
    return this.http.post(this.base_URL + "ticket/insertEComTicket", body)
  }

  addClientInfo(body: any) {
    return this.http.post(this.base_URL + 'client_info', body)
  }

  getAllClientInfo() {
    return this.http.get(this.base_URL + 'client_info/getAllClients')
  }

  getClientInfoByClientId(clientId: any, cid: any) {
    return this.http.get(this.base_URL + 'client_info/' + clientId + '/' + cid)
  }

  deleteClientInfo(id: any) {
    return this.http.delete(this.base_URL + 'client_info/hardDelete/' + id)
  }

  updateClientInfo(body: any) {
    return this.http.put(this.base_URL + 'client_info/update', body)
  }

  addBillingTerm(body: any) {
    return this.http.post(this.base_URL + 'billing_term', body)
  }

  editBillingTerm(body: any) {
    return this.http.put(this.base_URL + 'billing_term/update', body)
  }

  getAllBillingTerm() {
    return this.http.get(this.base_URL + 'billing_term/all/' + sessionStorage.getItem('cid'))
  }

  getAllBillingTermWithPagination(pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'billing_term/all/' + sessionStorage.getItem('cid') + '/' + pageNumber + '/' + recordsPerPage)
  }

  getAllBillingTermByWildSearch(searchKey: any, pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'billing_term/all/' + sessionStorage.getItem('cid') + "/" + searchKey + '/' + pageNumber + '/' + recordsPerPage)
  }

  getBillingTermById(billingTermId: any) {
    return this.http.get(this.base_URL + 'billing_term/' + billingTermId + '/' + sessionStorage.getItem('cid'))
  }

  deleteBillingTerm(id: any) {
    return this.http.delete(this.base_URL + 'billing_term/hardDelete/' + id)
  }



  addPaymentTerm(body: any) {
    return this.http.post(this.base_URL + 'payment_term', body)
  }

  editPaymentTerm(body: any) {
    return this.http.put(this.base_URL + 'payment_term/update', body)
  }

  getAllPaymentTerm() {
    return this.http.get(this.base_URL + 'payment_term/all/' + sessionStorage.getItem('cid') + "/0/10")
  }

  getAllPaymentTermWithPagination(pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'payment_term/all/' + sessionStorage.getItem('cid') + '/' + pageNumber + '/' + recordsPerPage)
  }

  getAllPaymentTermByWildSearch(searchKey: any, pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'payment_term/getAllTermServiceByWildSearch/' + searchKey + "/" + sessionStorage.getItem('cid') + '/' + pageNumber + '/' + recordsPerPage)
  }

  getPaymentTermById(billingTermId: any) {
    return this.http.get(this.base_URL + 'payment_term/' + billingTermId + '/' + sessionStorage.getItem('cid'))
  }

  deletePaymentTerm(id: any) {
    return this.http.delete(this.base_URL + 'payment_term/hardDelete/' + id)
  }

  getTicketDayWiseCountByDate(date: any) {
    return this.http.get(this.base_URL + 'ticket_day_wise_count/getTicketDayWiseCountByDate/' + date + "/" + sessionStorage.getItem('cid'))
  }

  getTicketDayWiseCountBetweenDates(listOfDates: any) {
    return this.http.get(this.base_URL + 'ticket_day_wise_count/getTicketDayWiseCountBetweenDates/' + listOfDates + "/" + sessionStorage.getItem('cid'))
  }

  getServiceTypeWiseTicketDayCountBetweenDates(listOfDates: any) {
    return this.http.get(this.base_URL + 'service_type_wise_ticket_day_count/getServiceTypeWiseTicketDayCountBetweenDates/' + listOfDates + "/" + sessionStorage.getItem('cid'))
  }

  service_type_wise_ticket_day_count() {
    return this.http.get(this.base_URL + 'service_type_wise_ticket_day_count/all/' + sessionStorage.getItem('cid'))
  }

  getServiceTypeWiseTicketDayCountByDate(date: any) {
    return this.http.get(this.base_URL + 'service_type_wise_ticket_day_count/getServiceTypeWiseTicketDayCountByDate/' + date + "/" + sessionStorage.getItem('cid'))
  }

  // getProspectsDayWiseCountByDate(date: any){
  //   return this.http.get(this.base_URL+'prospects_day_wise_count/getProspectsDayWiseCountByDate/'+date+"/"+sessionStorage.getItem('cid'))
  // }

  getProspectsDayWiseCountByDate(date: any) {
    return this.http.get(this.base_URL + 'prospects_day_wise_count/getProspectsDayWiseCountByDate/' + date + "/" + sessionStorage.getItem('cid'))
  }


  getUserDayWiseTaskCountBetweenDates(listOfDates: any) {
    return this.http.get(this.base_URL + 'user_day_wise_task_count/getUserDayWiseTaskCountBetweenDates/' + listOfDates + "/" + sessionStorage.getItem('cid'))
  }

  getNotificationByNotificationTypeAndNotificationReadStatus(notificationType: any, notificationReadStatus: any) {
    return this.http.get(this.base_URL + 'notification/getNotificationByNotificationTypeAndNotificationReadStatus/' + notificationType + "/" + notificationReadStatus + "/" + sessionStorage.getItem('cid'))
  }

  getNotificationByNotificationTypeAndNotificationReadStatusAndToUserId(notificationType: any, notificationReadStatus: any, userId: any, pageNo: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'notification/getNotificationByNotificationTypeAndNotificationReadStatusAndToUserId/' + notificationType + "/" + notificationReadStatus + "/" + userId + "/" + recordsPerPage + "/" + pageNo + "/" + sessionStorage.getItem('cid'))
  }

  updateReadStatus(readStatus: any, notificationId: any) {
    return this.http.put(this.base_URL + 'notification/updateReadStatus/' + readStatus + "/" + notificationId + "/" + sessionStorage.getItem('cid'), {})
  }


  //notification/getByToUserId/{cid}/{userId}/{notificationReadStatus}/{recordsPerPage}/{pageNo}
  getByToUserId(userId: any, notificationReadStatus: any, pageNo: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'notification/getByToUserId/' + sessionStorage.getItem('cid') + '/' + userId + '/' + notificationReadStatus + '/' + recordsPerPage + '/' + pageNo)
  }


  checkActionControls(privilegeName: string) {
    const userCredsStr = sessionStorage.getItem('userCreds');
    if (!userCredsStr) {
      return this.getDefaultActions();
    }

    const userCreds = JSON.parse(userCredsStr);
    console.log("userCreds", userCreds);
    console.log("privilegeName", privilegeName);

    // Optional chaining + early return
    const privilege = userCreds?.rolePrevilages
      ?.flatMap((r: any) => r.screenPrivilegeList)
      ?.find((p: any) => p.name === privilegeName);

    if (privilege) {
      console.log("privilege", privilege);
      return {
        isAdd: privilege.add ?? false,
        isView: privilege.view ?? false,
        isDelete: privilege.delete ?? false,
        isModify: privilege.modify ?? false,
        isVerify: privilege.verify ?? false,
        isApprove: privilege.approve ?? false,
        isIssue: privilege.issue ?? false,
        isAttach: privilege.attach ?? false,
        isRemove: privilege.remove ?? false
      };
    }

    return this.getDefaultActions();
  }

  private getDefaultActions() {
    return {
      isAdd: false,
      isView: false,
      isDelete: false,
      isModify: false,
      isVerify: false,
      isApprove: false,
      isIssue: false,
      isAttach: false,
      isRemove: false
    };
  }



  getAllCustomerLocationWiseExpenses() {
    return this.http.get(this.base_URL + 'customerLocationWiseExpenses/all/' + sessionStorage.getItem('cid'))
  }

  addCustomerLocationWiseExpenses(body: any) {
    return this.http.post(this.base_URL + 'customerLocationWiseExpenses', body)
  }

  deleteCustomerLocationWiseExpenses(id: any) {
    return this.http.delete(this.base_URL + 'customerLocationWiseExpenses/hardDelete/' + id)
  }

  getCustomerLocationWiseExpensesById(customerLocationWiseExpensesId: any) {
    return this.http.get(this.base_URL + 'customerLocationWiseExpenses/' + customerLocationWiseExpensesId + '/' + sessionStorage.getItem('cid'))
  }


  getCustomerLocationWiseExpensesByCustomerPhoneNumber(customerPhoneNumber: any) {
    return this.http.get(this.base_URL + 'customerLocationWiseExpenses/getCustomerLocationWiseExpensesByCustomerPhoneNumber/' + customerPhoneNumber + "/" + sessionStorage.getItem('cid'))
  }

  getCustomerLocationWiseExpensesByTranDate(transactionDate: any) {
    return this.http.get(this.base_URL + 'customerLocationWiseExpenses/getCustomerLocationWiseExpensesByTranDate/' + transactionDate + "/" + sessionStorage.getItem('cid'))
  }


  getCustomerLocationDayWiseExpensesTotalByDate(date: any) {
    return this.http.get(this.base_URL + 'customer_location_day_wise_expenses_total/getCustomerLocationDayWiseExpensesTotalByDate/' + date + "/" + sessionStorage.getItem('cid'))
  }

  getCustomerLocationDayWiseExpensesTotalByCustomerId(customerId: any, pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'customer_location_day_wise_expenses_total/getCustomerLocationDayWiseExpensesTotalByCustomerId/' + customerId + "/" + sessionStorage.getItem('cid') + '/' + recordsPerPage + '/' + pageNumber)
  }


  getMaterialPurchaseDayWiseCountBetweenDates(listOfDates: any) {
    return this.http.get(this.base_URL + 'material_purchase_day_wise_count/getMaterialPurchaseDayWiseCountBetweenDates/' + listOfDates + "/" + sessionStorage.getItem('cid'))
  }

  getAllMaterialPurchaseDayWiseCount() {
    return this.http.get(this.base_URL + 'material_purchase_day_wise_count/all/' + sessionStorage.getItem('cid'))
  }

  getMaterialIssuesDayWiseCountByDate(date: any) {
    return this.http.get(this.base_URL + 'material_issues_day_wise_count/getMaterialIssuesDayWiseCountByDate/' + date + "/" + sessionStorage.getItem('cid'))
  }

  getMaterialTransfersDayWiseCountByDate(date: any) {
    return this.http.get(this.base_URL + 'material_transfers_day_wise_count/getMaterialTransfersDayWiseCountByDate/' + date + "/" + sessionStorage.getItem('cid'))
  }

  getMaterialPurchaseDayWiseCountByDate(date: any) {
    return this.http.get(this.base_URL + 'material_purchase_day_wise_count/getMaterialPurchaseDayWiseCountByDate/' + date + "/" + sessionStorage.getItem('cid'))
  }

  getMaterialIssuesDayWiseCountBetweenDates(listOfDates: any) {
    return this.http.get(this.base_URL + 'material_issues_day_wise_count/getMaterialIssuesDayWiseCountBetweenDates/' + listOfDates + "/" + sessionStorage.getItem('cid'))
  }


  getMaterialTransfersDayWiseCountBetweenDates(listOfDates: any) {
    return this.http.get(this.base_URL + 'material_transfers_day_wise_count/getMaterialTransfersDayWiseCountBetweenDates/' + listOfDates + "/" + sessionStorage.getItem('cid'))
  }

  getAllMaterialIssuesDayWiseCount() {
    return this.http.get(this.base_URL + 'material_issues_day_wise_count/all/' + sessionStorage.getItem('cid'))
  }

  getAllMaterialTransfersDayWiseCount() {
    return this.http.get(this.base_URL + 'material_transfers_day_wise_count/all/' + sessionStorage.getItem('cid'))
  }

  addIndentInfo(body: any) {
    return this.http.post(this.base_URL + 'indent_info', body)
  }

  updateIndentInfo(body: any) {
    return this.http.put(this.base_URL + 'indent_info/update', body)
  }

  getAllIndentInfo(pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'indent_info/all/' + sessionStorage.getItem('cid') + '/' + pageNumber + '/' + recordsPerPage)
  }

  deleteIndentInfo(id: any) {
    return this.http.delete(this.base_URL + 'indent_info/hardDelete/' + id)
  }

  getIndentInfoById(indentInfoId: any) {
    return this.http.get(this.base_URL + 'indent_info/' + indentInfoId + "/" + sessionStorage.getItem('cid'))
  }

  getIndentInfoByStatus(indentStatus: any, pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'indent_info/getIndentInfoByStatus/' + indentStatus + "/" + sessionStorage.getItem('cid') + "/" + pageNumber + "/" + recordsPerPage)
  }

  getIndentInfoByStatusAndPhNo(indentStatus: any, phNo: any, pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'indent_info/getIndentInfoByStatusAndPhNo/' + indentStatus + "/" + phNo + "/" + sessionStorage.getItem('cid') + "/" + pageNumber + "/" + recordsPerPage)
  }

  getAllIndentInfoByWildSearch(searchKey: any, pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'indent_info/getAllIndentInfoByWildSearch/' + searchKey + "/" + sessionStorage.getItem('cid') + "/" + pageNumber + '/' + recordsPerPage)
  }

  getAllIndentInfoByWildSearchByStatus(searchKey: any, indentStatusInfo: any, pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'indent_info/getAllIndentInfoByWildSearchByStatus/' + searchKey + "/" + indentStatusInfo + "/" + sessionStorage.getItem('cid') + "/" + pageNumber + '/' + recordsPerPage)
  }

  getAllIndentInfoByWildSearchByStatusAndPhNo(searchKeyphNo: any, searchKey: any, indentStatusInfo: any, pageNumber: any, recordsPerPage: any) {
    return this.http.get(this.base_URL + 'indent_info/getAllIndentInfoByWildSearchByStatusAndPhNo/' + searchKeyphNo + "/" + searchKey + "/" + indentStatusInfo + "/" + sessionStorage.getItem('cid') + "/" + pageNumber + '/' + recordsPerPage)
  }


  // indent_info/getIndentInfoByStatusAndPhNo/RECEIVED/534/1/2/3

  updateIndentInfoStatus(body: any) {
    return this.http.put(this.base_URL + "indent_info/updateIndentInfoStatus/", body)
  }


  getDynamicUrlData(url: any) {
    return this.http.get(this.base_URL + url + "/" + sessionStorage.getItem('cid'))
  }


  addObjectCategory(body: any) {
    return this.http.post(this.base_URL + 'objectCategory', body)
  }

  getAllObjectCategory() {
    return this.http.get(this.base_URL + 'objectCategory/all/' + sessionStorage.getItem('cid'))
  }

  getObjectCategoryById(objectCategoryId: any) {
    return this.http.get(this.base_URL + 'objectCategory/' + objectCategoryId + '/' + sessionStorage.getItem('cid'))
  }

  deleteObjectCategory(id: any) {
    return this.http.delete(this.base_URL + 'objectCategory/hardDelete/' + id)
  }

  updateObjectCategory(body: any) {
    return this.http.put(this.base_URL + 'objectCategory/update', body)
  }

  getAllObjectCategorysByWildSearch(wildSearch: any) {
    return this.http.get(this.base_URL + 'objectCategory/getAllObjectCategorysByWildSearch/' + wildSearch + "/" + sessionStorage.getItem('cid'))
  }

  addDepreciationRegister(body: any) {
    return this.http.post(this.base_URL + 'depreciationRegister', body)
  }

  getAllDepreciationRegister() {
    return this.http.get(this.base_URL + 'depreciationRegister/all/' + sessionStorage.getItem('cid'))
  }

  getDepreciationRegisterById(depreciationRegisterId: any) {
    return this.http.get(this.base_URL + 'depreciationRegister/' + depreciationRegisterId + '/' + sessionStorage.getItem('cid'))
  }

  deleteDepreciationRegister(id: any) {
    return this.http.delete(this.base_URL + 'depreciationRegister/hardDelete/' + id)
  }

  updateDepreciationRegister(body: any) {
    return this.http.put(this.base_URL + 'depreciationRegister/update', body)
  }




  addAssetDepreciationMethod(body: any) {
    return this.http.post(this.base_URL + 'assetDepreciationMethod', body)
  }

  getAllAssetDepreciationMethod() {
    return this.http.get(this.base_URL + 'assetDepreciationMethod/all/' + sessionStorage.getItem('cid'))
  }

  getAllAssetDepreciationMethodByWildSearch(wildSearch: any) {
    return this.http.get(this.base_URL + 'assetDepreciationMethod/getAllAssetDepreciationMethodByWildSearch/' + wildSearch + "/" + sessionStorage.getItem('cid'))
  }

  getAssetDepreciationMethodById(assetDepreciationMethodId: any) {
    return this.http.get(this.base_URL + 'assetDepreciationMethod/' + assetDepreciationMethodId + '/' + sessionStorage.getItem('cid'))
  }

  deleteAssetDepreciationMethod(id: any) {
    return this.http.delete(this.base_URL + 'assetDepreciationMethod/hardDelete/' + id)
  }

  updateAssetDepreciationMethod(body: any) {
    return this.http.put(this.base_URL + 'assetDepreciationMethod/update', body)
  }


  addDepartment_info(body: any) {
    return this.http.post(this.base_URL + 'department_info', body)
  }

  getAllDepartment_info() {
    return this.http.get(this.base_URL + 'department_info/all/' + sessionStorage.getItem('cid'))
  }

  getAllDepartment_infoByCid(cid: any) {
    return this.http.get(this.base_URL + 'department_info/all/' + cid)
  }

  getDepartment_infoById(departmentInfoId: any) {
    return this.http.get(this.base_URL + 'department_info/' + departmentInfoId + '/' + sessionStorage.getItem('cid'))
  }

  getAllDepartmentInfosByWildSearch(wildSearch: any) {
    return this.http.get(this.base_URL + 'department_info/getAllDepartmentInfosByWildSearch/' + wildSearch + "/" + sessionStorage.getItem('cid'))
  }

  deleteDepartment_info(id: any) {
    return this.http.delete(this.base_URL + 'department_info/hardDelete/' + id)
  }

  updateDepartment_info(body: any) {
    return this.http.put(this.base_URL + 'department_info/update', body)
  }


  addAssetBudgeting(body: any) {
    return this.http.post(this.base_URL + 'assetBudgeting', body)
  }

  getAllAssetBudgeting() {
    return this.http.get(this.base_URL + 'assetBudgeting/all/' + sessionStorage.getItem('cid'))
  }

  // getAllAssetDepreciationMethodByWildSearch(wildSearch:any){
  //   return this.http.get(this.base_URL+'assetDepreciationMethod/getAllAssetDepreciationMethodByWildSearch/'+wildSearch+"/"+sessionStorage.getItem('cid'))
  // }

  getAssetBudgetingIdById(assetBudgetingId: any) {
    return this.http.get(this.base_URL + 'assetBudgeting/' + assetBudgetingId + '/' + sessionStorage.getItem('cid'))
  }

  deleteAssetBudgeting(id: any) {
    return this.http.delete(this.base_URL + 'assetBudgeting/hardDelete/' + id)
  }

  updateAssetBudgeting(body: any) {
    return this.http.put(this.base_URL + 'assetBudgeting/update', body)
  }




  getAllDepreciationHistory() {
    return this.http.get(this.base_URL + 'depreciationHistory/all/' + sessionStorage.getItem('cid'))
  }

  getAllCompatibleDepreciationHistorys(isCompatible: any) {
    return this.http.get(this.base_URL + 'depreciationHistory/getAllCompatibleDepreciationHistorys/' + isCompatible + '/' + sessionStorage.getItem('cid'))
  }

  getDepreciationHistoryById(depreciationHistoryId: any) {
    return this.http.get(this.base_URL + 'depreciationHistory/' + depreciationHistoryId + '/' + sessionStorage.getItem('cid'))
  }





  addAssetStatus(body: any) {
    return this.http.post(this.base_URL + 'assetStatus', body)
  }

  getAllAssetStatus() {
    return this.http.get(this.base_URL + 'assetStatus/all/' + sessionStorage.getItem('cid'))
  }

  // getAllAssetDepreciationMethodByWildSearch(wildSearch:any){
  //   return this.http.get(this.base_URL+'assetDepreciationMethod/getAllAssetDepreciationMethodByWildSearch/'+wildSearch+"/"+sessionStorage.getItem('cid'))
  // }

  getAssetStatusById(assetStatusId: any) {
    return this.http.get(this.base_URL + 'assetStatus/' + assetStatusId + '/' + sessionStorage.getItem('cid'))
  }

  deleteAssetStatus(id: any) {
    return this.http.delete(this.base_URL + 'assetStatus/hardDelete/' + id)
  }

  updateAssetStatus(body: any) {
    return this.http.put(this.base_URL + 'assetStatus/update', body)
  }







  fileData = '';


  CustomerRegistration(body: any) {
    const url = this.base_URL + 'prospectRegistration/update';
    return this.http.put(url, body)
  }

  generateEmailOtp(body: any) {
    const url = this.base_URL + 'prospectRegistration/generateEmailOtp';
    return this.http.post(url, body)
  }

  predefinedParameterEC(type: any) {
    const url = this.base_URL + 'predefinedParameter/getAllByType/';
    return this.http.get(url + 97110105107 + "/" + type)
  }

  verifyEmailOtp(body: any) {
    const url = this.base_URL + 'prospectRegistration/verifyEmailOtp';
    return this.http.post(url, body)
  }

  generatePhoneOtp(body: any) {
    const url = this.base_URL + 'prospectRegistration/generateMobileOtp';
    return this.http.post(url, body)
  }

  verifyPhoneOtp(body: any) {
    const url = this.base_URL + 'prospectRegistration/verifyPhoneOtp';
    return this.http.post(url, body)
  }

  uploadIdProofAttachmentEC(id: any, file: any, cid: any) {
    this.fileData = file
    const form: FormData = new FormData();
    form.append('file', file)
    console.log(file)
    const url = this.base_URL + 'prospectRegistration/uploadIdProofAttachment?id=' + id + '&cid=' + sessionStorage.getItem('cid');
    return this.http.post(url, form)
  }

  uploadPhotoAttachmentEC(id: any, file: any, cid: any) {
    this.fileData = file
    const form: FormData = new FormData();
    form.append('file', file)
    console.log(file)
    const url = this.base_URL + 'prospectRegistration/uploadPhotoAttachment?id=' + id + '&cid=' + sessionStorage.getItem('cid');
    return this.http.post(url, form)
  }
  ecCustomerRegistration(body: any) {
    const url = this.base_URL + 'existingCustomerInfo/update';
    return this.http.put(url, body)
  }

  ecGenerateEmailOtp(body: any) {
    const url = this.base_URL + 'existingCustomerInfo/generateEmailOtp';
    return this.http.post(url, body)
  }

  ecVerifyEmailOtp(body: any) {
    const url = this.base_URL + 'existingCustomerInfo/verifyEmailOtp';
    return this.http.post(url, body)
  }

  ecGeneratePhoneOtp(body: any) {
    const url = this.base_URL + 'existingCustomerInfo/generateMobileOtp';
    return this.http.post(url, body)
  }

  ecVerifyPhoneOtp(body: any) {
    const url = this.base_URL + 'existingCustomerInfo/verifyPhoneOtp';
    return this.http.post(url, body)
  }

  uploadImageEC(file: any) {
    console.log(file)
    let formData = new FormData();
    formData.append('file', file, file.name);
    const url = this.base_URL + 'upload-file/uploadFile?cid=' + sessionStorage.getItem('cid');
    return this.http.post(url, formData)
  }


  addTelcoCustomer(body: any) {
    return this.http.post(this.base_URL + 'telcoCustomer', body)
  }

  getAllTelcoCustomer() {
    return this.http.get(this.base_URL + 'telcoCustomer/all/' + sessionStorage.getItem('cid'))
  }

  getTelcoCustomerById(telcoCustomerId: any) {
    return this.http.get(this.base_URL + 'telcoCustomer/' + telcoCustomerId + '/' + sessionStorage.getItem('cid'))
  }

  updateTelcoCustomer(body: any) {
    return this.http.put(this.base_URL + 'telcoCustomer/update', body)
  }

  deleteTelcoCustomer(id: any) {
    return this.http.delete(this.base_URL + 'telcoCustomer/hardDelete/' + id)
  }

  telcoCustomerSoftDelete(id: any) {
    return this.http.delete(this.base_URL + 'telcoCustomer/softDelete/' + id)
  }

  getTelcoCustomerByWildSearch(wildSearch: any) {
    return this.http.get(this.base_URL + 'telcoCustomer/getTelcoCustomerByWildSearch/' + wildSearch + "/" + sessionStorage.getItem('cid'))
  }

  getTelcoCustomerByLocation(location: any) {
    return this.http.get(this.base_URL + 'telcoCustomer/getTelcoCustomerByLocation/' + location + "/" + sessionStorage.getItem('cid'))
  }


  getReportSelection(body: any) {
    return this.http.post(this.base_URL + 'clickhouse/reportSelection/', body)
  }

  assetAcquisitionReport(startDate: any, endDate: any, pageNumber: any, pageSize: any) {
    return this.http.post(this.base_URL + 'clickhouse/assetAcquisitionReport/' + sessionStorage.getItem('cid') + "/" + startDate + "/" + endDate + "/" + pageNumber + "/" + pageSize, '')
  }


  dashboardQueryTemp() {
    return this.http.get(this.base_URL + 'clickhouse/dashboardQueryTemp/')
  }

  /* ----- Asset Dashboard APIs ----- */

  assetsByTypePieChartDashboard() {
    return this.http.get(this.base_URL + 'clickhouse/assetsByTypePieChartDashboard/');
  }

  assetsAcrossYearsBarChartDashboard() {
    return this.http.get(this.base_URL + 'clickhouse/assetsAcrossYearsBarChartDashboard/');
  }

  assetsByTemplateBarChartDashboard() {
    return this.http.get(this.base_URL + 'clickhouse/assetsByTemplateBarChartDashboard/');
  }

  assetsOriginalCostByBranchPieChartDashboard() {
    return this.http.get(this.base_URL + 'clickhouse/assetsOriginalCostByBranchPieChartDashboard/');
  }

  assetsCurrentCostByBranchPieChartDashboard() {
    return this.http.get(this.base_URL + 'clickhouse/assetsCurrentCostByBranchPieChartDashboard/');
  }

  assetsCostByTypeBarChartDashboard() {
    return this.http.get(this.base_URL + 'clickhouse/assetsCostByTypeBarChartDashboard/');
  }

  /* ----- Ticket Dashboard APIs ----- */

  ticketsByStatusBarChartDashboard() {
    return this.http.get(this.base_URL + 'clickhouse/ticketsByStatusBarChartDashboard/');
  }

  ticketsByExpectedStartMonthBarChartDashboard() {
    return this.http.get(this.base_URL + 'clickhouse/ticketsByExpectedStartMonthBarChartDashboard/');
  }

  ticketsByExpectedClosingMonthBarChartDashboard() {
    return this.http.get(this.base_URL + 'clickhouse/ticketsByExpectedClosingMonthBarChartDashboard/');
  }

  amsAssetReportsSelection(body: any) {
    return this.http.post(this.base_URL + 'ams-asset-reports/selection/', body)
  }


  // clickhouse/assetsByTypePieChartDashboard/
  // clickhouse/assetsAcrossYearsBarChartDashboard/
  // clickhouse/assetsByTemplateBarChartDashboard/


  // clickhouse/assetsOriginalCostByBranchPieChartDashboard/
  // clickhouse/assetsCurrentCostByBranchPieChartDashboard/
  // clickhouse/assetsCostByTypeBarChartDashboard/

  // clickhouse/ticketsByStatusBarChartDashboard/
  // clickhouse/ticketsByExpectedStartMonthBarChartDashboard/
  // clickhouse/ticketsByExpectedClosingMonthBarChartDashboard/

  addCompanyInfo(body: any) {
    return this.http.post(this.base_URL + 'companyInfo', body);
  }

  getAllCompanyInfo(cid: any) {
    return this.http.get(this.base_URL + 'companyInfo/all/' + cid);
  }

  getCompanyInfoById(id: any, cid: any) {
    return this.http.get(this.base_URL + 'companyInfo/' + id + '/' + cid);
  }

  addSingleAppPropertiesConfig(body: any) {
    return this.http.post(this.base_URL + 'appPropertiesConfig', body);
  }

  addAppPropertiesConfig(body: any) {
    return this.http.post(this.base_URL + 'appPropertiesConfig/insertMultipleAppConfig', body);
  }

  getAllAppPropertiesConfig(cid: any) {
    return this.http.get(this.base_URL + 'appPropertiesConfig/all/' + cid);
  }

  updateAppPropertiesConfig(body: any) {
    return this.http.put(this.base_URL + 'appPropertiesConfig/update', body);
  }

  updateAppProperty(body: any) {
    return this.http.put(this.base_URL + 'appPropertiesConfig/update', body);
  }

  deleteCompanyInfo(id: any) {
    return this.http.delete(this.base_URL + 'companyInfo/hardDelete/' + id);
  }


  updateBlockStatus(companyInfoId: any, isBlocked: boolean) {
    return this.http.put(this.base_URL + 'companyInfo/updateBlockStatus/' + companyInfoId + '/' + isBlocked, {});
  }

}